import moment from 'moment';
import { stringify } from 'querystring';
import axios from 'axios';
import { useState, useRef } from 'react';
import i18next from 'i18next';
import Cookies from 'js-cookie';
import htmlReactParser from 'html-react-parser';

// import {report} from '@freelog/resource-policy-lang/dist';
// import {ContractEntity} from '@freelog/resource-policy-lang/dist/tools/ContractTool';
// const {compile} = require('@freelog/resource-policy-lang');
/**
 * 将对应的字节数，转换为易读单位数量
 * @param bytes
 * @return {string}
 */
function humanizeSize(bytes) {
  // console.log('dddhumanizeSizesdfsd');
  if (bytes <= 0) {
    return '0 B';
  }
  var unitArr = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
  var index = Math.floor(Math.log(bytes) / Math.log(1024));
  var size = Math.round(bytes / Math.pow(1024, index) * 100) / 100; //保留的小数位数
  return size + ' ' + unitArr[index];
}
/**
 * 格式化日期时间
 */
function formatDateTime(date, showTime) {
  if (showTime === void 0) {
    showTime = false;
  }
  return moment(date).format('YYYY/MM/DD' + (showTime ? ' HH:mm' : ''));
}
/**
 * 根据传入的子域名拼合成完整的适合的url
 * @param domain 要组合的三级域名
 */
function completeUrlByDomain(domain) {
  var origin = "https://" + domain + ".testfreelog.com";
  if (window.location.origin.includes('.freelog.com')) {
    origin = "https://" + domain + ".freelog.com";
  }
  return origin;
}
/**
 * 根据策略代码和标的物类型，生成对应的翻译
 * @param code 策略代码
 * @param targetType 标的物类型
 */
// export async function policyCodeTranslationToText(code: string, targetType: string): Promise<{
//   error: string[] | null;
//   text?: string;
// }> {
//   try {
//     const result = await compile(
//       code,
//       targetType,
//       completeUrlByDomain('qi'),
//       window.location.origin.endsWith('.freelog.com') ? 'prod' : 'dev',
//     );
//     const contract: ContractEntity = {
//       audiences: result.state_machine.audiences,
//       fsmStates: Object.entries<any>(result.state_machine.states)
//         .map((st) => {
//           return {
//             name: st[0],
//             serviceStates: st[1].serviceStates,
//             events: st[1].transitions.map((ts: any) => {
//
//               return {
//                 id: ts.code,
//                 name: ts.name,
//                 args: ts.args,
//                 state: ts.toState,
//               };
//             }),
//           };
//         }),
//     };
//     const rrr = report(contract);
//     return {
//       error: null,
//       text: rrr.audienceInfos[0].content + rrr.content,
//     };
//   } catch (err) {
//     return {
//       error: [err.message],
//     };
//   }
// }
/**
 * 将资源类型关键字数组,转换成标准展示文字
 * @param arr 关键字数组
 */
function resourceTypeKeyArrToResourceType(arr) {
  return arr.join(' / ');
}

var Format = {
  __proto__: null,
  humanizeSize: humanizeSize,
  formatDateTime: formatDateTime,
  completeUrlByDomain: completeUrlByDomain,
  resourceTypeKeyArrToResourceType: resourceTypeKeyArrToResourceType
};

// 展品名称
var EXHIBIT_NAME = /*#__PURE__*/new RegExp(/^(?!.*(\\|\/|:|\*|\?|"|<|>|\||\s|@|\$|#)).{1,60}$/);
// 资源名称
var RESOURCE_NAME = /*#__PURE__*/new RegExp(/^(?!.*(\\|\/|:|\*|\?|"|<|>|\||\s|@|\$|#)).{1,60}$/);
// 资源类型
var RESOURCE_TYPE = /*#__PURE__*/new RegExp("^[\u4E00-\u9FEFa-zA-Z0-9\\-&.,]{1,40}$");
// 自定义属性键
// export const CUSTOM_KEY: RegExp = new RegExp(/^[a-zA-Z_]([a-zA-Z0-9_]{1,19})?$/);
var CUSTOM_KEY = /*#__PURE__*/new RegExp('^[a-zA-Z]([a-zA-Z0-9_]{1,29})?$');
// 节点名称
var NODE_NAME = /*#__PURE__*/new RegExp(/^[\u4E00-\u9FA5|a-zA-Z0-9]{2,24}$/);
// 节点地址
// export const NODE_DOMAIN: RegExp = new RegExp(/^(?!-)[a-z0-9-]{4,24}(?<!-)$/);
var NODE_DOMAIN = /*#__PURE__*/new RegExp(/^[a-z0-9][a-z0-9-]{2,22}[a-z0-9]$/);
// 支付密码
var PAY_PASSWORD = /*#__PURE__*/new RegExp(/^\d{6}$/);
// 手机号码
var MOBILE_PHONE_NUMBER = /*#__PURE__*/new RegExp(/^1[345789]\d{9}$/);
// export const TELEPHONE_NUMBER = /^((13[0-9])|(14[5-9])|(15([0-3]|[5-9]))|(16[6-7])|(17[1-8])|(18[0-9])|(19[1|3])|(19[5|6])|(19[8|9]))\d{8}$/
// 邮箱地址
var EMAIL_ADDRESS = /*#__PURE__*/new RegExp(/^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/);
// 用户名
// export const USERNAME: RegExp = new RegExp(/^(?!-)[A-Za-z0-9-]{1,30}(?<!-)$/);
var USERNAME = /*#__PURE__*/new RegExp(/^([A-Za-z0-9][A-Za-z0-9-]{0,28})?[A-Za-z0-9]$/);
// 用户密码
// export const PASSWORD = /^(?=.*[a-zA-Z])(?=.*[0-9]).{6,24}$/;
var PASSWORD = /*#__PURE__*/new RegExp(/^(?=.*[0-9])(?=.*[a-zA-Z])(.{6,24})$/);
// 自然数
var NATURAL_NUMBER = /*#__PURE__*/new RegExp(/^[0-9]*$/);
// 正整数
var POSITIVE_INTEGER = /*#__PURE__*/new RegExp(/^[1-9]\d*$/);
// 最多两位小数的正数
// export const MAX_2_DECIMAL_POSITIVE_NUMBER = new RegExp(/^\d+(.\d{1,2})?$/);
var MAX_2_DECIMAL_POSITIVE_NUMBER = /*#__PURE__*/new RegExp(/^\d+(\.\d{0,2})?$/);
// 对象的Bucket名称
var BUCKET_NAME = /*#__PURE__*/new RegExp(/^([a-z0-9][a-z0-9-]{0,61})?[a-z0-9]$/);
// JS变量名称
var JS_VARIABLE_NAME = /*#__PURE__*/new RegExp(/^[A-Za-z$_][\w$_]*$/);
// 日期
var DATE = /*#__PURE__*/new RegExp(/(([0-9]{3}[1-9]|[0-9]{2}[1-9][0-9]{1}|[0-9]{1}[1-9][0-9]{2}|[1-9][0-9]{3})-(((0[13578]|1[02])-(0[1-9]|[12][0-9]|3[01]))|((0[469]|11)-(0[1-9]|[12][0-9]|30))|(02-(0[1-9]|[1][0-9]|2[0-8]))))|((([0-9]{2})(0[48]|[2468][048]|[13579][26])|((0[48]|[2468][048]|[3579][26])00))-02-29)$/);
// 日期时间
var DATE_TIME = /*#__PURE__*/new RegExp(/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/);

var Regexp = {
  __proto__: null,
  EXHIBIT_NAME: EXHIBIT_NAME,
  RESOURCE_NAME: RESOURCE_NAME,
  RESOURCE_TYPE: RESOURCE_TYPE,
  CUSTOM_KEY: CUSTOM_KEY,
  NODE_NAME: NODE_NAME,
  NODE_DOMAIN: NODE_DOMAIN,
  PAY_PASSWORD: PAY_PASSWORD,
  MOBILE_PHONE_NUMBER: MOBILE_PHONE_NUMBER,
  EMAIL_ADDRESS: EMAIL_ADDRESS,
  USERNAME: USERNAME,
  PASSWORD: PASSWORD,
  NATURAL_NUMBER: NATURAL_NUMBER,
  POSITIVE_INTEGER: POSITIVE_INTEGER,
  MAX_2_DECIMAL_POSITIVE_NUMBER: MAX_2_DECIMAL_POSITIVE_NUMBER,
  BUCKET_NAME: BUCKET_NAME,
  JS_VARIABLE_NAME: JS_VARIABLE_NAME,
  DATE: DATE,
  DATE_TIME: DATE_TIME
};

function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function _objectDestructuringEmpty(t) {
  if (null == t) throw new TypeError("Cannot destructure " + t);
}
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (e.includes(n)) continue;
    t[n] = r[n];
  }
  return t;
}
function _regeneratorRuntime() {
  _regeneratorRuntime = function () {
    return e;
  };
  var t,
    e = {},
    r = Object.prototype,
    n = r.hasOwnProperty,
    o = Object.defineProperty || function (t, e, r) {
      t[e] = r.value;
    },
    i = "function" == typeof Symbol ? Symbol : {},
    a = i.iterator || "@@iterator",
    c = i.asyncIterator || "@@asyncIterator",
    u = i.toStringTag || "@@toStringTag";
  function define(t, e, r) {
    return Object.defineProperty(t, e, {
      value: r,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), t[e];
  }
  try {
    define({}, "");
  } catch (t) {
    define = function (t, e, r) {
      return t[e] = r;
    };
  }
  function wrap(t, e, r, n) {
    var i = e && e.prototype instanceof Generator ? e : Generator,
      a = Object.create(i.prototype),
      c = new Context(n || []);
    return o(a, "_invoke", {
      value: makeInvokeMethod(t, r, c)
    }), a;
  }
  function tryCatch(t, e, r) {
    try {
      return {
        type: "normal",
        arg: t.call(e, r)
      };
    } catch (t) {
      return {
        type: "throw",
        arg: t
      };
    }
  }
  e.wrap = wrap;
  var h = "suspendedStart",
    l = "suspendedYield",
    f = "executing",
    s = "completed",
    y = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  var p = {};
  define(p, a, function () {
    return this;
  });
  var d = Object.getPrototypeOf,
    v = d && d(d(values([])));
  v && v !== r && n.call(v, a) && (p = v);
  var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
  function defineIteratorMethods(t) {
    ["next", "throw", "return"].forEach(function (e) {
      define(t, e, function (t) {
        return this._invoke(e, t);
      });
    });
  }
  function AsyncIterator(t, e) {
    function invoke(r, o, i, a) {
      var c = tryCatch(t[r], t, o);
      if ("throw" !== c.type) {
        var u = c.arg,
          h = u.value;
        return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) {
          invoke("next", t, i, a);
        }, function (t) {
          invoke("throw", t, i, a);
        }) : e.resolve(h).then(function (t) {
          u.value = t, i(u);
        }, function (t) {
          return invoke("throw", t, i, a);
        });
      }
      a(c.arg);
    }
    var r;
    o(this, "_invoke", {
      value: function (t, n) {
        function callInvokeWithMethodAndArg() {
          return new e(function (e, r) {
            invoke(t, n, e, r);
          });
        }
        return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      }
    });
  }
  function makeInvokeMethod(e, r, n) {
    var o = h;
    return function (i, a) {
      if (o === f) throw Error("Generator is already running");
      if (o === s) {
        if ("throw" === i) throw a;
        return {
          value: t,
          done: !0
        };
      }
      for (n.method = i, n.arg = a;;) {
        var c = n.delegate;
        if (c) {
          var u = maybeInvokeDelegate(c, n);
          if (u) {
            if (u === y) continue;
            return u;
          }
        }
        if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) {
          if (o === h) throw o = s, n.arg;
          n.dispatchException(n.arg);
        } else "return" === n.method && n.abrupt("return", n.arg);
        o = f;
        var p = tryCatch(e, r, n);
        if ("normal" === p.type) {
          if (o = n.done ? s : l, p.arg === y) continue;
          return {
            value: p.arg,
            done: n.done
          };
        }
        "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
      }
    };
  }
  function maybeInvokeDelegate(e, r) {
    var n = r.method,
      o = e.iterator[n];
    if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
    var i = tryCatch(o, e.iterator, r.arg);
    if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
    var a = i.arg;
    return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
  }
  function pushTryEntry(t) {
    var e = {
      tryLoc: t[0]
    };
    1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
  }
  function resetTryEntry(t) {
    var e = t.completion || {};
    e.type = "normal", delete e.arg, t.completion = e;
  }
  function Context(t) {
    this.tryEntries = [{
      tryLoc: "root"
    }], t.forEach(pushTryEntry, this), this.reset(!0);
  }
  function values(e) {
    if (e || "" === e) {
      var r = e[a];
      if (r) return r.call(e);
      if ("function" == typeof e.next) return e;
      if (!isNaN(e.length)) {
        var o = -1,
          i = function next() {
            for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
            return next.value = t, next.done = !0, next;
          };
        return i.next = i;
      }
    }
    throw new TypeError(typeof e + " is not iterable");
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
    value: GeneratorFunctionPrototype,
    configurable: !0
  }), o(GeneratorFunctionPrototype, "constructor", {
    value: GeneratorFunction,
    configurable: !0
  }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) {
    var e = "function" == typeof t && t.constructor;
    return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
  }, e.mark = function (t) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
  }, e.awrap = function (t) {
    return {
      __await: t
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () {
    return this;
  }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) {
    void 0 === i && (i = Promise);
    var a = new AsyncIterator(wrap(t, r, n, o), i);
    return e.isGeneratorFunction(r) ? a : a.next().then(function (t) {
      return t.done ? t.value : a.next();
    });
  }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () {
    return this;
  }), define(g, "toString", function () {
    return "[object Generator]";
  }), e.keys = function (t) {
    var e = Object(t),
      r = [];
    for (var n in e) r.push(n);
    return r.reverse(), function next() {
      for (; r.length;) {
        var t = r.pop();
        if (t in e) return next.value = t, next.done = !1, next;
      }
      return next.done = !0, next;
    };
  }, e.values = values, Context.prototype = {
    constructor: Context,
    reset: function (e) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
    },
    stop: function () {
      this.done = !0;
      var t = this.tryEntries[0].completion;
      if ("throw" === t.type) throw t.arg;
      return this.rval;
    },
    dispatchException: function (e) {
      if (this.done) throw e;
      var r = this;
      function handle(n, o) {
        return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
      }
      for (var o = this.tryEntries.length - 1; o >= 0; --o) {
        var i = this.tryEntries[o],
          a = i.completion;
        if ("root" === i.tryLoc) return handle("end");
        if (i.tryLoc <= this.prev) {
          var c = n.call(i, "catchLoc"),
            u = n.call(i, "finallyLoc");
          if (c && u) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          } else if (c) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
          } else {
            if (!u) throw Error("try statement without catch or finally");
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          }
        }
      }
    },
    abrupt: function (t, e) {
      for (var r = this.tryEntries.length - 1; r >= 0; --r) {
        var o = this.tryEntries[r];
        if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
          var i = o;
          break;
        }
      }
      i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
      var a = i ? i.completion : {};
      return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
    },
    complete: function (t, e) {
      if ("throw" === t.type) throw t.arg;
      return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
    },
    finish: function (t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
      }
    },
    catch: function (t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.tryLoc === t) {
          var n = r.completion;
          if ("throw" === n.type) {
            var o = n.arg;
            resetTryEntry(r);
          }
          return o;
        }
      }
      throw Error("illegal catch attempt");
    },
    delegateYield: function (e, r, n) {
      return this.delegate = {
        iterator: values(e),
        resultName: r,
        nextLoc: n
      }, "next" === this.method && (this.arg = t), y;
    }
  }, e;
}

var _excluded = ["resourceID"],
  _excluded2 = ["nodeID", "showPage"],
  _excluded3 = ["exhibitID"],
  _excluded4 = ["nodeID", "showPage"],
  _excluded5 = ["goTo"],
  _excluded6 = ["goTo"],
  _excluded7 = ["goTo", "returnUrl"];
function home(_temp) {
  _objectDestructuringEmpty(_temp === void 0 ? {} : _temp);
  return "/home";
}
function activities(_temp2) {
  _objectDestructuringEmpty(_temp2 === void 0 ? {} : _temp2);
  return "/activities";
}
function activity(_ref3) {
  var activityID = _ref3.activityID;
  return "/activity/" + activityID;
}
function dashboard(_temp3) {
  _objectDestructuringEmpty(_temp3 === void 0 ? {} : _temp3);
  return "/dashboard";
}
function market(_temp4) {
  var _ref5 = _temp4 === void 0 ? {} : _temp4,
    params = _extends({}, (_objectDestructuringEmpty(_ref5), _ref5));
  return "/market" + handleQuery(params);
}
function exampleNodes(_temp5) {
  _objectDestructuringEmpty(_temp5 === void 0 ? {} : _temp5);
  return "/examples";
}
function resourceDetails(_ref7) {
  var resourceID = _ref7.resourceID,
    params = _objectWithoutPropertiesLoose(_ref7, _excluded);
  return "/resource/details/" + resourceID + handleQuery(params);
}
function collectionDetails(_ref8) {
  var collectionID = _ref8.collectionID;
  return "/resource/collectionDetails/" + collectionID;
}
function resourceCreatorEntry(_temp6) {
  _objectDestructuringEmpty(_temp6 === void 0 ? {} : _temp6);
  return "/resource/creatorEntry";
}
function resourceCreator(_temp7) {
  _objectDestructuringEmpty(_temp7 === void 0 ? {} : _temp7);
  return "/resource/creator";
}
function resourceCreatorBatch(_temp8) {
  _objectDestructuringEmpty(_temp8 === void 0 ? {} : _temp8);
  return "/resource/creatorBatch";
}
function collectionCreator(_temp9) {
  _objectDestructuringEmpty(_temp9 === void 0 ? {} : _temp9);
  return "/resource/collectionCreator";
}
function myResources(_temp10) {
  _objectDestructuringEmpty(_temp10 === void 0 ? {} : _temp10);
  return "/resource/list";
}
function myCollections(_temp11) {
  _objectDestructuringEmpty(_temp11 === void 0 ? {} : _temp11);
  return "/resource/collection";
}
function myCollects(_temp12) {
  _objectDestructuringEmpty(_temp12 === void 0 ? {} : _temp12);
  return "/resource/collect";
}
function resourceVersionInfo(_ref16) {
  var resourceID = _ref16.resourceID,
    _ref16$version = _ref16.version,
    version = _ref16$version === void 0 ? '' : _ref16$version;
  return "/resource/sidebar/versionInfo/" + resourceID + handleQuery({
    version: version
  });
}
function resourceInfo(_ref17) {
  var resourceID = _ref17.resourceID;
  return "/resource/sidebar/info/" + resourceID;
}
function resourcePolicy(_ref18) {
  var resourceID = _ref18.resourceID;
  return "/resource/sidebar/policy/" + resourceID;
}
function resourceContract(_ref19) {
  var resourceID = _ref19.resourceID;
  return "/resource/sidebar/contract/" + resourceID;
}
function resourceDependency(_ref20) {
  var resourceID = _ref20.resourceID;
  return "/resource/sidebar/dependency/" + resourceID;
}
function resourceVersionCreator(_ref21) {
  var resourceID = _ref21.resourceID;
  return "/resource/versionCreator/" + resourceID;
}
function collectionVersionInfo(_ref22) {
  var collectionID = _ref22.collectionID;
  return "/resource/collectionSidebar/versionInfo/" + collectionID;
}
function collectionInfo(_ref23) {
  var collectionID = _ref23.collectionID;
  return "/resource/collectionSidebar/info/" + collectionID;
}
function collectionPolicy(_ref24) {
  var collectionID = _ref24.collectionID;
  return "/resource/collectionSidebar/policy/" + collectionID;
}
function collectionContract(_ref25) {
  var collectionID = _ref25.collectionID;
  return "/resource/collectionSidebar/contract/" + collectionID;
}
function collectionDependency(_ref26) {
  var collectionID = _ref26.collectionID;
  return "/resource/collectionSidebar/dependency/" + collectionID;
}
function nodeCreator(_temp13) {
  _objectDestructuringEmpty(_temp13 === void 0 ? {} : _temp13);
  return "/node/creator";
}
function nodeManagement(_ref28) {
  var nodeID = _ref28.nodeID,
    _ref28$showPage = _ref28.showPage,
    showPage = _ref28$showPage === void 0 ? 'exhibit' : _ref28$showPage,
    params = _objectWithoutPropertiesLoose(_ref28, _excluded2);
  return "/node/formal/" + nodeID + handleQuery(_extends({
    showPage: showPage
  }, params));
}
function exhibitManagement(_ref29) {
  var exhibitID = _ref29.exhibitID,
    params = _objectWithoutPropertiesLoose(_ref29, _excluded3);
  return "/node/exhibit/formal/" + exhibitID + handleQuery(_extends({}, params));
}
function collectionExhibitManagement(_ref30) {
  var exhibitID = _ref30.exhibitID,
    openAuthDrawer = _ref30.openAuthDrawer;
  return "/node/collectionExhibit/formal/" + exhibitID + handleQuery({
    openAuthDrawer: openAuthDrawer
  });
}
function informNodeManagement(_ref31) {
  var nodeID = _ref31.nodeID,
    _ref31$showPage = _ref31.showPage,
    showPage = _ref31$showPage === void 0 ? 'exhibit' : _ref31$showPage,
    params = _objectWithoutPropertiesLoose(_ref31, _excluded4);
  return "/node/informal/" + nodeID + handleQuery(_extends({
    showPage: showPage
  }, params));
}
function informExhibitManagement(_ref32) {
  var exhibitID = _ref32.exhibitID;
  return "/node/exhibit/informal/" + exhibitID;
}
function storageSpace(_temp14) {
  var _ref33 = _temp14 === void 0 ? {} : _temp14,
    params = _extends({}, (_objectDestructuringEmpty(_ref33), _ref33));
  return "/storage" + handleQuery(params);
}
function objectDetails(_ref34) {
  var params = _extends({}, (_objectDestructuringEmpty(_ref34), _ref34));
  return "/storage" + handleQuery(params);
}
function collectionCreateSuccess(_ref35) {
  var collectionID = _ref35.collectionID;
  return "/result/collection/create/success/" + collectionID;
}
function resourceCreateSuccess(_ref36) {
  var resourceID = _ref36.resourceID;
  return "/result/resource/create/success/" + resourceID;
}
function resourceVersionCreateSuccess(_ref37) {
  var resourceID = _ref37.resourceID,
    version = _ref37.version;
  return "/result/resource/version/create/success/" + resourceID + "/" + version;
}
function resourceVersionCreateRelease(_ref38) {
  var resourceID = _ref38.resourceID,
    version = _ref38.version;
  return "/result/resource/version/create/release/" + resourceID + "/" + version;
}
function nodeCreateSuccess(_ref39) {
  var nodeID = _ref39.nodeID;
  return "/result/node/create/success/" + nodeID;
}
function invitation(_temp15) {
  var _ref40 = _temp15 === void 0 ? {} : _temp15,
    goTo = _ref40.goTo,
    params = _objectWithoutPropertiesLoose(_ref40, _excluded5);
  // console.log(params.goTo, 'goTo9iowjefklsdj;flksdjflk')
  return "/invitation" + handleQuery(_extends({}, params, {
    returnUrl: goTo ? encodeURIComponent(goTo) : undefined
  }));
}
function exception403(_temp16) {
  var _ref41 = _temp16 === void 0 ? {} : _temp16,
    params = _extends({}, (_objectDestructuringEmpty(_ref41), _ref41));
  var fromUrl = params.from || '';
  if (!fromUrl) {
    var _window$location = window.location,
      href = _window$location.href,
      origin = _window$location.origin;
    fromUrl = href.replace(origin, '');
  }
  return "/exception/403" + handleQuery({
    from: fromUrl
  });
}
function exceptionUnableToAccess(_temp17) {
  var _ref42 = _temp17 === void 0 ? {} : _temp17,
    params = _extends({}, (_objectDestructuringEmpty(_ref42), _ref42));
  var fromUrl = params.from || '';
  if (!fromUrl) {
    var _window$location2 = window.location,
      href = _window$location2.href,
      origin = _window$location2.origin;
    fromUrl = href.replace(origin, '');
  }
  return "/exception/unableToAccess" + handleQuery({
    from: fromUrl
  });
}
function nodeFreeze(_ref43) {
  var nodeID = _ref43.nodeID;
  return "/result/node/freeze/" + nodeID;
}
function resourceFreeze(_ref44) {
  var resourceID = _ref44.resourceID;
  return "/result/resource/freeze/" + resourceID;
}
function globalSearch(_ref45) {
  var search = _ref45.search;
  return "/search" + handleQuery({
    search: search
  });
}
function login(_temp18) {
  var _ref46 = _temp18 === void 0 ? {} : _temp18,
    goTo = _ref46.goTo;
  return "/login" + handleQuery({
    goTo: goTo ? encodeURIComponent(goTo) : undefined
  });
}
function logon(_temp19) {
  var _ref47 = _temp19 === void 0 ? {} : _temp19,
    goTo = _ref47.goTo,
    params = _objectWithoutPropertiesLoose(_ref47, _excluded6);
  return "/logon" + handleQuery(_extends({
    goTo: goTo ? encodeURIComponent(goTo) : undefined
  }, params));
}
function bind(_temp20) {
  var _ref48 = _temp20 === void 0 ? {} : _temp20,
    goTo = _ref48.goTo,
    returnUrl = _ref48.returnUrl,
    params = _objectWithoutPropertiesLoose(_ref48, _excluded7);
  return "/bind" + handleQuery(_extends({
    goTo: goTo ? encodeURIComponent(goTo) : undefined,
    returnUrl: returnUrl ? encodeURIComponent(returnUrl) : undefined
  }, params));
}
function retrieveUserPassword(_temp21) {
  var _ref49 = _temp21 === void 0 ? {} : _temp21,
    goTo = _ref49.goTo;
  return "/retrieve" + handleQuery({
    goTo: goTo ? encodeURIComponent(goTo) : undefined
  });
}
function retrievePayPassword(_temp22) {
  _objectDestructuringEmpty(_temp22 === void 0 ? {} : _temp22);
  return "/retrievePayPassword";
}
function userFreeze(_temp23) {
  _objectDestructuringEmpty(_temp23 === void 0 ? {} : _temp23);
  return "/freeze";
}
function wallet(_temp24) {
  _objectDestructuringEmpty(_temp24 === void 0 ? {} : _temp24);
  return "/logged/wallet";
}
function reward(_temp25) {
  _objectDestructuringEmpty(_temp25 === void 0 ? {} : _temp25);
  return "/logged/reward";
}
function contract(_temp26) {
  var _ref54 = _temp26 === void 0 ? {} : _temp26,
    params = _extends({}, (_objectDestructuringEmpty(_ref54), _ref54));
  return "/logged/contract" + handleQuery(_extends({}, params));
}
function setting(_temp27) {
  _objectDestructuringEmpty(_temp27 === void 0 ? {} : _temp27);
  return "/logged/setting";
}
function binding(_temp28) {
  _objectDestructuringEmpty(_temp28 === void 0 ? {} : _temp28);
  return "/logged/binding";
}
function resultBindingSuccess(_temp29) {
  _objectDestructuringEmpty(_temp29 === void 0 ? {} : _temp29);
  return "/result/binding";
}
/************** user End ******************************************************/
function handleQuery(query) {
  var obj = {};
  for (var _i = 0, _Object$entries = Object.entries(query); _i < _Object$entries.length; _i++) {
    var _Object$entries$_i = _Object$entries[_i],
      key = _Object$entries$_i[0],
      value = _Object$entries$_i[1];
    if (key && value) {
      obj[key] = value;
    }
  }
  var result = stringify(obj);
  return result ? '?' + result : '';
}

var LinkTo = {
  __proto__: null,
  home: home,
  activities: activities,
  activity: activity,
  dashboard: dashboard,
  market: market,
  exampleNodes: exampleNodes,
  resourceDetails: resourceDetails,
  collectionDetails: collectionDetails,
  resourceCreatorEntry: resourceCreatorEntry,
  resourceCreator: resourceCreator,
  resourceCreatorBatch: resourceCreatorBatch,
  collectionCreator: collectionCreator,
  myResources: myResources,
  myCollections: myCollections,
  myCollects: myCollects,
  resourceVersionInfo: resourceVersionInfo,
  resourceInfo: resourceInfo,
  resourcePolicy: resourcePolicy,
  resourceContract: resourceContract,
  resourceDependency: resourceDependency,
  resourceVersionCreator: resourceVersionCreator,
  collectionVersionInfo: collectionVersionInfo,
  collectionInfo: collectionInfo,
  collectionPolicy: collectionPolicy,
  collectionContract: collectionContract,
  collectionDependency: collectionDependency,
  nodeCreator: nodeCreator,
  nodeManagement: nodeManagement,
  exhibitManagement: exhibitManagement,
  collectionExhibitManagement: collectionExhibitManagement,
  informNodeManagement: informNodeManagement,
  informExhibitManagement: informExhibitManagement,
  storageSpace: storageSpace,
  objectDetails: objectDetails,
  collectionCreateSuccess: collectionCreateSuccess,
  resourceCreateSuccess: resourceCreateSuccess,
  resourceVersionCreateSuccess: resourceVersionCreateSuccess,
  resourceVersionCreateRelease: resourceVersionCreateRelease,
  nodeCreateSuccess: nodeCreateSuccess,
  invitation: invitation,
  exception403: exception403,
  exceptionUnableToAccess: exceptionUnableToAccess,
  nodeFreeze: nodeFreeze,
  resourceFreeze: resourceFreeze,
  globalSearch: globalSearch,
  login: login,
  logon: logon,
  bind: bind,
  retrieveUserPassword: retrieveUserPassword,
  retrievePayPassword: retrievePayPassword,
  userFreeze: userFreeze,
  wallet: wallet,
  reward: reward,
  contract: contract,
  setting: setting,
  binding: binding,
  resultBindingSuccess: resultBindingSuccess
};

// export const apiHost = `${window.location.protocol}//qi.${(window.location.host.match(/(?<=\.).*/) || [''])[0]}`;
// 预设资源类型
var resourceTypes = ['json', 'widget', 'image', 'audio', 'markdown', 'theme', 'reveal_slide', 'license', 'video', 'catalog'];
// 全局列表加载条目数
var pageSize = 100;
// Moment 日期时间格式
var momentDateFormat = 'YYYY-MM-DD';
var momentDateTimeFormat = 'YYYY-MM-DD HH:mm';
// 签约方用户的身份类型定义
var EnumContractPartyIdentityType;
(function (EnumContractPartyIdentityType) {
  EnumContractPartyIdentityType[EnumContractPartyIdentityType["resource"] = 1] = "resource";
  EnumContractPartyIdentityType[EnumContractPartyIdentityType["node"] = 2] = "node";
  EnumContractPartyIdentityType[EnumContractPartyIdentityType["consumer"] = 3] = "consumer";
})(EnumContractPartyIdentityType || (EnumContractPartyIdentityType = {}));
// 标的物类型定义
var EnumSubjectType;
(function (EnumSubjectType) {
  EnumSubjectType[EnumSubjectType["resource"] = 1] = "resource";
  EnumSubjectType[EnumSubjectType["exhibit"] = 2] = "exhibit";
  EnumSubjectType[EnumSubjectType["user"] = 3] = "user";
})(EnumSubjectType || (EnumSubjectType = {}));
// 合约状态定义
var EnumContractStatus;
(function (EnumContractStatus) {
  EnumContractStatus[EnumContractStatus["pending"] = 0] = "pending";
  EnumContractStatus[EnumContractStatus["authorized"] = 1] = "authorized";
  EnumContractStatus[EnumContractStatus["stopped"] = 2] = "stopped";
})(EnumContractStatus || (EnumContractStatus = {}));
// 合约授权状态定义
// export enum ContractAuthStatus {
//
// }

var Predefined = {
  __proto__: null,
  resourceTypes: resourceTypes,
  pageSize: pageSize,
  momentDateFormat: momentDateFormat,
  momentDateTimeFormat: momentDateTimeFormat,
  get EnumContractPartyIdentityType () { return EnumContractPartyIdentityType; },
  get EnumSubjectType () { return EnumSubjectType; },
  get EnumContractStatus () { return EnumContractStatus; }
};

function create(params) {
  // return FUtil.Axios.post('/v2/nodes', params);
  return FUtil.Request({
    method: 'POST',
    url: "/v2/nodes",
    data: params
  });
}
function details(params) {
  if (params.nodeId) {
    // return FUtil.Axios.get(`/v2/nodes/${(params as NodeDetailParamsType1).nodeId}`);
    return FUtil.Request({
      method: 'GET',
      url: "/v2/nodes/" + params.nodeId
    });
  }
  // return FUtil.Axios.get(`/v2/nodes/detail`, {
  //   params,
  // });
  return FUtil.Request({
    method: 'GET',
    url: "/v2/nodes/detail",
    params: params
  });
}
function nodes(params) {
  return FUtil.Request({
    method: 'GET',
    url: "/v2/nodes",
    params: params
  });
}
function searchForClient(params) {
  return FUtil.Request({
    method: 'GET',
    url: "/v2/nodes/searchForClient",
    params: params
  });
}
function setNodeInfo(params) {
  return FUtil.Request({
    method: 'POST',
    url: "/v2/nodes/setNodeInfo",
    data: params
  });
}
function deleteNode(_ref) {
  var nodeId = _ref.nodeId;
  return FUtil.Request({
    method: 'DELETE',
    url: "/v2/nodes/" + nodeId
  });
}

var Node = {
  __proto__: null,
  create: create,
  details: details,
  nodes: nodes,
  searchForClient: searchForClient,
  setNodeInfo: setNodeInfo,
  deleteNode: deleteNode
};

var _excluded$1 = ["presentableId"],
  _excluded2$1 = ["presentableId"],
  _excluded3$1 = ["presentableId"],
  _excluded4$1 = ["presentableId"],
  _excluded5$1 = ["presentableId"],
  _excluded6$1 = ["presentableId"],
  _excluded7$1 = ["presentableId"],
  _excluded8 = ["presentableId"],
  _excluded9 = ["nodeId"],
  _excluded10 = ["nodeId"],
  _excluded11 = ["presentableId"];
function createPresentable(params) {
  return FUtil.Request({
    method: 'POST',
    url: "/v2/presentables",
    data: params
  });
}
function updatePresentable(_ref) {
  var presentableId = _ref.presentableId,
    params = _objectWithoutPropertiesLoose(_ref, _excluded$1);
  return FUtil.Request({
    method: 'PUT',
    url: "/v2/presentables/" + presentableId,
    data: params
  });
}
function presentablesOnlineStatus(_ref2) {
  var presentableId = _ref2.presentableId,
    params = _objectWithoutPropertiesLoose(_ref2, _excluded2$1);
  return FUtil.Request({
    method: 'PUT',
    url: "/v2/presentables/" + presentableId + "/onlineStatus",
    data: params
  });
}
function presentableDetails(params) {
  if (params.nodeId) {
    return FUtil.Request({
      method: 'GET',
      url: "/v2/presentables/detail",
      params: params
    });
  }
  var presentableId = params.presentableId,
    p = _objectWithoutPropertiesLoose(params, _excluded3$1);
  return FUtil.Request({
    method: 'GET',
    url: "/v2/presentables/" + presentableId,
    params: p
  });
}
function presentables(params) {
  return FUtil.Request({
    method: 'GET',
    url: "/v2/presentables",
    params: params
  });
}
function presentableList(params) {
  return FUtil.Request({
    method: 'GET',
    url: "/v2/presentables/list",
    params: params
  });
}
function dependencyTree(_ref3) {
  var presentableId = _ref3.presentableId,
    params = _objectWithoutPropertiesLoose(_ref3, _excluded4$1);
  return FUtil.Request({
    method: 'GET',
    url: "/v2/presentables/" + presentableId + "/dependencyTree",
    params: params
  });
}
function relationTree(_ref4) {
  var presentableId = _ref4.presentableId,
    params = _objectWithoutPropertiesLoose(_ref4, _excluded5$1);
  return FUtil.Request({
    method: 'GET',
    url: "/v2/presentables/" + presentableId + "/relationTree",
    params: params
  });
}
function authTree(_ref5) {
  var presentableId = _ref5.presentableId,
    params = _objectWithoutPropertiesLoose(_ref5, _excluded6$1);
  return FUtil.Request({
    method: 'GET',
    url: "/v2/presentables/" + presentableId + "/authTree",
    params: params
  });
}
function presentablesVersion(_ref6) {
  var presentableId = _ref6.presentableId,
    params = _objectWithoutPropertiesLoose(_ref6, _excluded7$1);
  return FUtil.Request({
    method: 'PUT',
    url: "/v2/presentables/" + presentableId + "/version",
    data: params
  });
}
function updateRewriteProperty(_ref7) {
  var presentableId = _ref7.presentableId,
    params = _objectWithoutPropertiesLoose(_ref7, _excluded8);
  return FUtil.Request({
    method: 'PUT',
    url: "/v2/presentables/" + presentableId + "/rewriteProperty",
    data: params
  });
}
function batchAuth(_ref8) {
  var nodeId = _ref8.nodeId,
    params = _objectWithoutPropertiesLoose(_ref8, _excluded9);
  return FUtil.Request({
    method: 'GET',
    url: "/v2/auths/presentables/nodes/" + nodeId + "/batchAuth/result",
    params: params
  });
}
function contractAppliedPresentable(_ref9) {
  var nodeId = _ref9.nodeId,
    params = _objectWithoutPropertiesLoose(_ref9, _excluded10);
  return FUtil.Request({
    method: 'GET',
    url: "/v2/presentables/" + nodeId + "/contractAppliedPresentable",
    params: params
  });
}
function batchCreatePresentable(params) {
  return FUtil.Request({
    method: 'POST',
    url: "/v2/presentables/createPresentableBatchEasy",
    data: params
  });
}
function batchUpdatePresentable(_ref10) {
  var params = _extends({}, (_objectDestructuringEmpty(_ref10), _ref10));
  return FUtil.Request({
    method: 'PUT',
    url: "/v2/presentables/updatePresentableBatch",
    data: params
  });
}
function batchUpdatePresentableStatus(_ref11) {
  var params = _extends({}, (_objectDestructuringEmpty(_ref11), _ref11));
  return FUtil.Request({
    method: 'PUT',
    url: "/v2/presentables/updatePresentableOnlineStatusBatch",
    data: params
  });
}
function ignorePresentableVersionUpdateTip(_ref12) {
  var presentableId = _ref12.presentableId,
    params = _objectWithoutPropertiesLoose(_ref12, _excluded11);
  return FUtil.Request({
    method: 'POST',
    url: "/v2/presentables/" + presentableId + "/ignorePresentableVersionUpdateTip",
    data: params
  });
}

var Exhibit = {
  __proto__: null,
  createPresentable: createPresentable,
  updatePresentable: updatePresentable,
  presentablesOnlineStatus: presentablesOnlineStatus,
  presentableDetails: presentableDetails,
  presentables: presentables,
  presentableList: presentableList,
  dependencyTree: dependencyTree,
  relationTree: relationTree,
  authTree: authTree,
  presentablesVersion: presentablesVersion,
  updateRewriteProperty: updateRewriteProperty,
  batchAuth: batchAuth,
  contractAppliedPresentable: contractAppliedPresentable,
  batchCreatePresentable: batchCreatePresentable,
  batchUpdatePresentable: batchUpdatePresentable,
  batchUpdatePresentableStatus: batchUpdatePresentableStatus,
  ignorePresentableVersionUpdateTip: ignorePresentableVersionUpdateTip
};

var _excluded$2 = ["bucketName"],
  _excluded2$2 = ["bucketName"],
  _excluded3$2 = ["objectIdOrName"],
  _excluded4$2 = ["sha1"],
  _excluded5$2 = ["objectIdOrName"];
function createBucket(params) {
  return FUtil.Request({
    method: 'POST',
    url: "/v2/storages/buckets",
    data: params
  });
}
function bucketList(params) {
  return FUtil.Request({
    method: 'GET',
    url: "/v2/storages/buckets",
    params: params
  });
}
function spaceStatistics(params) {
  if (params === void 0) {
    params = {};
  }
  return FUtil.Request({
    method: 'GET',
    url: "/v2/storages/buckets/spaceStatistics",
    params: params
  });
}
function deleteBucket(params) {
  return FUtil.Request({
    method: 'DELETE',
    url: "/v2/storages/buckets/" + params.bucketName
  });
}
function bucketDetails(_ref) {
  var bucketName = _ref.bucketName;
  return FUtil.Request({
    method: 'GET',
    url: "/v2/storages/buckets/" + bucketName
  });
}
function objectList(_ref2) {
  var bucketName = _ref2.bucketName,
    params = _objectWithoutPropertiesLoose(_ref2, _excluded$2);
  return FUtil.Request({
    method: 'GET',
    url: "/v2/storages/buckets/" + bucketName + "/objects",
    params: params
  });
}
function userNodeDataList(params) {
  return FUtil.Request({
    method: 'GET',
    url: "/v2/storages/buckets/.UserNodeData/objects",
    params: params
  });
}
function createObject(_ref3) {
  var bucketName = _ref3.bucketName,
    params = _objectWithoutPropertiesLoose(_ref3, _excluded2$2);
  return FUtil.Request({
    method: 'POST',
    url: "/v2/storages/buckets/" + bucketName + "/objects",
    data: params
  });
}
function objectDetails$1(params) {
  if (params.objectIdOrName) {
    return FUtil.Request({
      method: 'GET',
      url: "/v2/storages/objects/" + encodeURIComponent(params.objectIdOrName),
      params: params
    });
  }
  return FUtil.Request({
    method: 'GET',
    url: "/v2/storages/buckets/" + params.bucketName + "/objects/" + params.objectId,
    params: params
  });
}
function deleteObjects(params) {
  return FUtil.Request({
    method: 'DELETE',
    url: "/v2/storages/buckets/" + params.bucketName + "/objects/" + params.objectIds
  });
}
function bucketIsExist(_ref4) {
  var bucketName = _ref4.bucketName;
  return FUtil.Request({
    method: 'GET',
    url: "/v2/storages/buckets/" + bucketName + "/isExist"
  });
}
function downloadObject(params) {
  return window.location.href = FUtil.Format.completeUrlByDomain('api') + ("/v2/storages/objects/" + params.objectIdOrName + "/file");
}
function fileIsExist(params) {
  return FUtil.Request({
    method: 'GET',
    url: "/v2/storages/files/fileIsExist",
    params: params
  });
}
function uploadFile(params, config, returnCancel) {
  if (returnCancel === void 0) {
    returnCancel = false;
  }
  var formData = new FormData();
  for (var _i = 0, _Object$entries = Object.entries(params); _i < _Object$entries.length; _i++) {
    var _Object$entries$_i = _Object$entries[_i],
      key = _Object$entries$_i[0],
      value = _Object$entries$_i[1];
    if (value) {
      formData.append(key, value);
    }
  }
  if (!returnCancel) {
    // return FUtil.Axios.post('/v2/storages/files/upload', formData, config);
    return FUtil.Request(_extends({
      method: 'POST',
      url: "/v2/storages/files/upload",
      data: formData
    }, config));
  }
  var cancel = null;
  // const promise = FUtil.Axios.post('/v2/storages/files/upload', formData, {
  //   cancelToken: new FUtil.Axios.CancelToken((c) => {
  //     cancel = c;
  //   }),
  // });
  var promise = FUtil.Request(_extends({
    method: 'POST',
    url: "/v2/storages/files/upload",
    data: formData,
    cancelToken: new FUtil.Axios.CancelToken(function (c) {
      cancel = c;
    })
  }, config));
  return [promise, cancel];
}
function uploadImage(params, config) {
  var formData = new FormData();
  for (var _i2 = 0, _Object$entries2 = Object.entries(params); _i2 < _Object$entries2.length; _i2++) {
    var _Object$entries2$_i = _Object$entries2[_i2],
      key = _Object$entries2$_i[0],
      value = _Object$entries2$_i[1];
    if (value) {
      formData.append(key, value);
    }
  }
  return FUtil.Request(_extends({
    method: 'POST',
    url: "/v2/storages/files/uploadImage",
    data: formData
  }, config));
}
function handleImage(params) {
  return FUtil.Request({
    method: 'POST',
    url: "/v2/storages/files/imageHandle",
    data: params
  });
}
function generateCoverImage(params) {
  return FUtil.Request({
    method: 'POST',
    url: "/v2/storages/files/generateCoverImage",
    data: params
  });
}
function updateObject(_ref5) {
  var objectIdOrName = _ref5.objectIdOrName,
    params = _objectWithoutPropertiesLoose(_ref5, _excluded3$2);
  return FUtil.Request({
    method: 'PUT',
    url: "/v2/storages/objects/" + objectIdOrName,
    data: params
  });
}
function batchUpdateObject(_ref6) {
  var params = _extends({}, (_objectDestructuringEmpty(_ref6), _ref6));
  return FUtil.Request({
    method: 'PUT',
    url: "/v2/storages/objects/updateBatch",
    data: params
  });
}
function batchObjectList(params) {
  return FUtil.Request({
    method: 'GET',
    url: "/v2/storages/objects/list",
    params: params
  });
}
function fileProperty(_ref7) {
  var sha1 = _ref7.sha1,
    params = _objectWithoutPropertiesLoose(_ref7, _excluded4$2);
  return FUtil.Request({
    method: 'GET',
    url: "/v2/storages/files/" + sha1 + "/property",
    params: params
  });
}
function cycleDependencyCheck(_ref8) {
  var objectIdOrName = _ref8.objectIdOrName,
    params = _objectWithoutPropertiesLoose(_ref8, _excluded5$2);
  return FUtil.Request({
    method: 'POST',
    url: "/v2/storages/objects/" + objectIdOrName + "/cycleDependencyCheck",
    data: params
  });
}
function clearUserNodeData(_ref9) {
  var params = _extends({}, (_objectDestructuringEmpty(_ref9), _ref9));
  return FUtil.Request({
    method: 'DELETE',
    url: "/v2/storages/buckets/.UserNodeData/objects/clear",
    data: params
  });
}
function filesListInfo(_ref10) {
  var params = _extends({}, (_objectDestructuringEmpty(_ref10), _ref10));
  return FUtil.Request({
    method: 'GET',
    url: "/v2/storages/files/list/info",
    params: params
  });
}
function filesInfo(_ref11) {
  var params = _extends({}, (_objectDestructuringEmpty(_ref11), _ref11));
  return FUtil.Request({
    method: 'GET',
    url: "/v2/storages/files/info",
    params: params
  });
}

var Storage = {
  __proto__: null,
  createBucket: createBucket,
  bucketList: bucketList,
  spaceStatistics: spaceStatistics,
  deleteBucket: deleteBucket,
  bucketDetails: bucketDetails,
  objectList: objectList,
  userNodeDataList: userNodeDataList,
  createObject: createObject,
  objectDetails: objectDetails$1,
  deleteObjects: deleteObjects,
  bucketIsExist: bucketIsExist,
  downloadObject: downloadObject,
  fileIsExist: fileIsExist,
  uploadFile: uploadFile,
  uploadImage: uploadImage,
  handleImage: handleImage,
  generateCoverImage: generateCoverImage,
  updateObject: updateObject,
  batchUpdateObject: batchUpdateObject,
  batchObjectList: batchObjectList,
  fileProperty: fileProperty,
  cycleDependencyCheck: cycleDependencyCheck,
  clearUserNodeData: clearUserNodeData,
  filesListInfo: filesListInfo,
  filesInfo: filesInfo
};

function collectResource(params) {
  // return FUtil.Axios.post('/v2/collections/resources', params);
  return FUtil.Request({
    method: 'POST',
    url: "/v2/collections/resources",
    data: params
  });
}
function collectionResources(params) {
  return FUtil.Request({
    method: 'GET',
    url: "/v2/collections/resources",
    params: params
  });
}
function deleteCollectResource(_ref) {
  var resourceId = _ref.resourceId;
  // return FUtil.Axios.delete(`/v2/collections/resources/${resourceId}`);
  return FUtil.Request({
    method: 'DELETE',
    url: "/v2/collections/resources/" + resourceId
  });
}
function isCollected(params) {
  // return FUtil.Axios.get('/v2/collections/resources/isCollected', {
  //   params
  // });
  return FUtil.Request({
    method: 'GET',
    url: "/v2/collections/resources/isCollected",
    params: params
  });
}
function collectedCount(_ref2) {
  var resourceId = _ref2.resourceId;
  // return FUtil.Axios.get(`/v2/collections/resources/${resourceId}/count`);
  return FUtil.Request({
    method: 'GET',
    url: "/v2/collections/resources/" + resourceId + "/count"
  });
}

var Collection = {
  __proto__: null,
  collectResource: collectResource,
  collectionResources: collectionResources,
  deleteCollectResource: deleteCollectResource,
  isCollected: isCollected,
  collectedCount: collectedCount
};

var _excluded$3 = ["resourceIdOrName"],
  _excluded2$3 = ["resourceId"],
  _excluded3$3 = ["resourceId"],
  _excluded4$3 = ["resourceId"],
  _excluded5$3 = ["resourceId", "version"],
  _excluded6$2 = ["resourceId"],
  _excluded7$2 = ["fileSha1"],
  _excluded8$1 = ["fileSha1"],
  _excluded9$1 = ["resourceId"],
  _excluded10$1 = ["resourceId"],
  _excluded11$1 = ["resourceId"],
  _excluded12 = ["resourceId"],
  _excluded13 = ["resourceId"],
  _excluded14 = ["resourceId"],
  _excluded15 = ["resourceId"],
  _excluded16 = ["resourceId"],
  _excluded17 = ["resourceId"],
  _excluded18 = ["resourceId"],
  _excluded19 = ["resourceId"],
  _excluded20 = ["resourceId"],
  _excluded21 = ["resourceId"],
  _excluded22 = ["resourceId"],
  _excluded23 = ["resourceId"],
  _excluded24 = ["resourceId"],
  _excluded25 = ["resourceId", "itemId"],
  _excluded26 = ["resourceId"],
  _excluded27 = ["resourceId"];
function create$1(params) {
  return FUtil.Request({
    method: 'POST',
    url: "/v2/resources",
    data: params
  });
}
function createBatch(params) {
  return FUtil.Request({
    method: 'POST',
    url: "/v2/resources/createBatch",
    data: params
  });
}
function update(params) {
  return FUtil.Request({
    method: 'PUT',
    url: "/v2/resources/" + params.resourceId,
    data: params
  });
}
function batchUpdate(params) {
  return FUtil.Request({
    method: 'PUT',
    url: "/v2/resources/updateBatch",
    data: params
  });
}
// interface ListReturnType extends CommonReturn {
//   data: IResourceInfo[];
// }
function list(params) {
  return FUtil.Request({
    method: 'GET',
    url: "/v2/resources",
    params: params
  });
}
// interface InfoReturnType extends CommonReturn {
//   data: IResourceInfo
// }
function info(_ref) {
  var resourceIdOrName = _ref.resourceIdOrName,
    params = _objectWithoutPropertiesLoose(_ref, _excluded$3);
  // : Promise<InfoReturnType>
  return FUtil.Request({
    method: 'GET',
    url: "/v2/resources/" + encodeURIComponent(resourceIdOrName),
    params: params
  });
}
// interface BatchInfoReturnType extends CommonReturn {
//   data: IResourceInfo[];
// }
function batchInfo(params) {
  // : Promise<BatchInfoReturnType>
  return FUtil.Request({
    method: 'GET',
    url: "/v2/resources/list",
    params: params
  });
}
function dependencyTree$1(_ref2) {
  var resourceId = _ref2.resourceId,
    params = _objectWithoutPropertiesLoose(_ref2, _excluded2$3);
  return FUtil.Request({
    method: 'GET',
    url: "/v2/resources/" + resourceId + "/dependencyTree",
    params: params
  });
}
function authTree$1(_ref3) {
  var resourceId = _ref3.resourceId,
    params = _objectWithoutPropertiesLoose(_ref3, _excluded3$3);
  return FUtil.Request({
    method: 'GET',
    url: "/v2/resources/" + resourceId + "/authTree",
    params: params
  });
}
function createVersion(_ref4) {
  var resourceId = _ref4.resourceId,
    params = _objectWithoutPropertiesLoose(_ref4, _excluded4$3);
  // return FUtil.Axios.post(`/v2/resources/${resourceId}/versions`, params);
  return FUtil.Request({
    method: 'POST',
    url: "/v2/resources/" + resourceId + "/versions",
    data: params
  });
}
function resourceVersionInfo1(_ref5) {
  var resourceId = _ref5.resourceId,
    version = _ref5.version,
    params = _objectWithoutPropertiesLoose(_ref5, _excluded5$3);
  return FUtil.Request({
    method: 'GET',
    url: "/v2/resources/" + resourceId + "/versions/" + version,
    params: params
  });
}
function resourceVersionInfo2(params) {
  return FUtil.Request({
    method: 'GET',
    url: "/v2/resources/versions/detail",
    params: params
  });
}
function getVersionListByResourceID(_ref6) {
  var resourceId = _ref6.resourceId,
    params = _objectWithoutPropertiesLoose(_ref6, _excluded6$2);
  return FUtil.Request({
    method: 'GET',
    url: "/v2/resources/" + resourceId + "/versions",
    params: params
  });
}
function getVersionList(_ref7) {
  var params = _extends({}, (_objectDestructuringEmpty(_ref7), _ref7));
  return FUtil.Request({
    method: 'GET',
    url: "/v2/resources/versions/list",
    params: params
  });
}
function getResourceVersionBySha1(_ref8) {
  var fileSha1 = _ref8.fileSha1,
    params = _objectWithoutPropertiesLoose(_ref8, _excluded7$2);
  return FUtil.Request({
    method: 'GET',
    url: "/v2/resources/files/" + fileSha1 + "/versions",
    params: params
  });
}
function getResourceBySha1(_ref9) {
  var fileSha1 = _ref9.fileSha1,
    params = _objectWithoutPropertiesLoose(_ref9, _excluded8$1);
  // return FUtil.Axios.get(`/v2/resources/files/${fileSha1}`, {
  //   params,
  // });
  return FUtil.Request({
    method: 'GET',
    url: "/v2/resources/files/" + fileSha1,
    params: params
  });
}
function updateResourceVersionInfo(params) {
  // return FUtil.Axios.put(`/v2/resources/${params.resourceId}/versions/${params.version}`, params);
  return FUtil.Request({
    method: 'PUT',
    url: "/v2/resources/" + params.resourceId + "/versions/" + params.version,
    data: params
  });
}
function saveVersionsDraft(params) {
  // return FUtil.Axios.post(`/v2/resources/${params.resourceId}/versions/drafts`, params);
  return FUtil.Request({
    method: 'POST',
    url: "/v2/resources/" + params.resourceId + "/versions/drafts",
    data: params
  });
}
function lookDraft(params) {
  // return FUtil.Axios.get(`/v2/resources/${params.resourceId}/versions/drafts`);
  return FUtil.Request({
    method: 'GET',
    url: "/v2/resources/" + params.resourceId + "/versions/drafts",
    params: params
  });
}
function deleteResourceDraft(_ref10) {
  var resourceId = _ref10.resourceId;
  // return FUtil.Axios.post(`/v2/resources/${params.resourceId}/versions/drafts`, params);
  return FUtil.Request({
    method: 'DELETE',
    url: "/v2/resources/" + resourceId + "/versions/drafts"
  });
}
function resourceIsUsedByOther(params) {
  // return FUtil.Axios.get(`/v2/resources/versions/isCanBeCreate`, {
  //   params,
  // });
  return FUtil.Request({
    method: 'GET',
    url: "/v2/resources/versions/isCanBeCreate",
    params: params
  });
}
function resourcesDownload(params) {
  return window.location.href = FUtil.Format.completeUrlByDomain('api') + ("/v2/resources/" + params.resourceId + "/versions/" + params.version + "/download");
  // return request.get(`/v2/resources/${params.resourceId}/versions/${params.$version}/download`, {
  //   responseType: 'arraybuffer',
  // });
}
function batchGetCoverageVersions(_ref11) {
  var resourceId = _ref11.resourceId,
    params = _objectWithoutPropertiesLoose(_ref11, _excluded9$1);
  // return FUtil.Axios.get(`/v2/resources/${resourceId}/contracts/coverageVersions`, {
  //   params,
  // });
  return FUtil.Request({
    method: 'GET',
    url: "/v2/resources/" + resourceId + "/contracts/coverageVersions",
    params: params
  });
}
function resolveResources(params) {
  // return FUtil.Axios.get(`/v2/resources/${params.resourceId}/resolveResources`);
  return FUtil.Request({
    method: 'GET',
    url: "/v2/resources/" + params.resourceId + "/resolveResources"
  });
}
function batchSetContracts(_ref12) {
  var resourceId = _ref12.resourceId,
    params = _objectWithoutPropertiesLoose(_ref12, _excluded10$1);
  // return FUtil.Axios.put(`/v2/resources/${resourceId}/versions/batchSetContracts`, params);
  return FUtil.Request({
    method: 'PUT',
    url: "/v2/resources/" + resourceId + "/versions/batchSetContracts",
    data: params
  });
}
function cycleDependencyCheck$1(_ref13) {
  var resourceId = _ref13.resourceId,
    params = _objectWithoutPropertiesLoose(_ref13, _excluded11$1);
  // return FUtil.Axios.post(`/v2/resources/${resourceId}/versions/cycleDependencyCheck`, params);
  return FUtil.Request({
    method: 'POST',
    url: "/v2/resources/" + resourceId + "/versions/cycleDependencyCheck",
    data: params
  });
}
function relationTree$1(_ref14) {
  var resourceId = _ref14.resourceId,
    params = _objectWithoutPropertiesLoose(_ref14, _excluded12);
  // return FUtil.Axios.get(`/v2/resources/${resourceId}/relationTree`, {
  //   params,
  // });
  return FUtil.Request({
    method: 'GET',
    url: "/v2/resources/" + resourceId + "/relationTree",
    params: params
  });
}
function relationTreeAuth(_ref15) {
  var resourceId = _ref15.resourceId,
    params = _objectWithoutPropertiesLoose(_ref15, _excluded13);
  return FUtil.Request({
    method: 'GET',
    url: "/v2/auths/resources/" + resourceId + "/relationTreeAuth",
    params: params
  });
}
function resourcesCount(_ref16) {
  var params = _extends({}, (_objectDestructuringEmpty(_ref16), _ref16));
  return FUtil.Request({
    method: 'GET',
    url: "/v2/resources/count",
    params: params
  });
}
function batchAuth$1(_ref17) {
  var params = _extends({}, (_objectDestructuringEmpty(_ref17), _ref17));
  return FUtil.Request({
    method: 'GET',
    url: "/v2/auths/resources/batchAuth/results",
    params: params
  });
}
function resourcesRecommend(_ref18) {
  var params = _extends({}, (_objectDestructuringEmpty(_ref18), _ref18));
  return FUtil.Request({
    method: 'GET',
    url: "/v2/resources/recommend",
    params: params
  });
}
function availableTags(_ref19) {
  var params = _extends({}, (_objectDestructuringEmpty(_ref19), _ref19));
  return FUtil.Request({
    method: 'GET',
    url: "/v2/resources/tags/availableTags",
    params: params
  });
}
function resourceTypes$1(_temp) {
  var _ref20 = _temp === void 0 ? {} : _temp,
    params = _extends({}, (_objectDestructuringEmpty(_ref20), _ref20));
  return FUtil.Request({
    method: 'GET',
    url: "/v2/resources/types/listSimpleByGroup",
    params: params
  });
}
function ListSimpleByParentCode(_ref21) {
  var params = _extends({}, (_objectDestructuringEmpty(_ref21), _ref21));
  return FUtil.Request({
    method: 'GET',
    url: "/v2/resources/types/listSimpleByParentCode",
    params: params
  });
}
function getResourceTypeInfoByCode(_ref22) {
  var params = _extends({}, (_objectDestructuringEmpty(_ref22), _ref22));
  return FUtil.Request({
    method: 'GET',
    url: "/v2/resources/types/getInfoByCode",
    params: params
  });
}
function getResourceAttrListSimple(_ref23) {
  var params = _extends({}, (_objectDestructuringEmpty(_ref23), _ref23));
  return FUtil.Request({
    method: 'GET',
    url: "/v2/resources/attrs/listSimple",
    params: params
  });
}
function listSimple4Recently(_temp2) {
  var _ref24 = _temp2 === void 0 ? {} : _temp2,
    params = _extends({}, (_objectDestructuringEmpty(_ref24), _ref24));
  return FUtil.Request({
    method: 'GET',
    url: "/v2/resources/types/listSimple4Recently",
    params: params
  });
}
function getAttrsInfoByKey(_ref25) {
  var params = _extends({}, (_objectDestructuringEmpty(_ref25), _ref25));
  return FUtil.Request({
    method: 'GET',
    url: "/v2/resources/attrs/getInfoByKey",
    params: params
  });
}
function generateResourceNames(_ref26) {
  var resourceNames = _ref26.resourceNames;
  return FUtil.Request({
    method: 'POST',
    url: "/v2/resources/generateResourceNames",
    data: {
      resourceNames: resourceNames
    }
  });
}
function updateCollection(_ref27) {
  var resourceId = _ref27.resourceId,
    params = _objectWithoutPropertiesLoose(_ref27, _excluded14);
  return FUtil.Request({
    method: 'PUT',
    url: "/v2/resources/catalogue/" + resourceId,
    data: params
  });
}
function deleteCollectionUnitResource(_ref28) {
  var resourceId = _ref28.resourceId,
    removeCollectionItemIds = _ref28.removeCollectionItemIds;
  return FUtil.Request({
    method: 'DELETE',
    url: "/v2/resources/catalogue/" + resourceId + "?removeCollectionItemIds=" + removeCollectionItemIds.join(',')
  });
}
function getCollectionItems(_ref29) {
  var resourceId = _ref29.resourceId,
    params = _objectWithoutPropertiesLoose(_ref29, _excluded15);
  return FUtil.Request({
    method: 'GET',
    url: "/v2/resources/catalogue/" + resourceId + "/items",
    params: params
  });
}
function getCollectionItems_Draft(_ref30) {
  var resourceId = _ref30.resourceId,
    params = _objectWithoutPropertiesLoose(_ref30, _excluded16);
  return FUtil.Request({
    method: 'GET',
    url: "/v2/resources/catalogues/drafts/" + resourceId + "/items",
    params: params
  });
}
function setCollectionItemSort(_ref31) {
  var resourceId = _ref31.resourceId,
    params = _objectWithoutPropertiesLoose(_ref31, _excluded17);
  return FUtil.Request({
    method: 'PUT',
    url: "/v2/resources/catalogue/" + resourceId + "/manualSort",
    data: params
  });
}
function reorderCollectionItemsSort(_ref32) {
  var resourceId = _ref32.resourceId,
    params = _objectWithoutPropertiesLoose(_ref32, _excluded18);
  return FUtil.Request({
    method: 'PUT',
    url: "/v2/resources/catalogue/" + resourceId + "/reorder",
    data: params
  });
}
function checkExistCollectionItems(_ref33) {
  var resourceId = _ref33.resourceId,
    params = _objectWithoutPropertiesLoose(_ref33, _excluded19);
  return FUtil.Request({
    method: 'GET',
    url: "/v2/resources/catalogue/" + resourceId + "/items/checkExists",
    params: params
  });
}
function getCollectionItemsAuth(_ref34) {
  var resourceId = _ref34.resourceId,
    params = _objectWithoutPropertiesLoose(_ref34, _excluded20);
  return FUtil.Request({
    method: 'GET',
    url: "/v2/auths/resources/" + resourceId + "/items/batchAuth",
    params: params
  });
}
function batchResourceItems(_ref35) {
  var params = _extends({}, (_objectDestructuringEmpty(_ref35), _ref35));
  return FUtil.Request({
    method: 'GET',
    url: "/v2/resources/catalogue/items/batch/list",
    params: params
  });
}
function batchResourceItems_Draft(_ref36) {
  var params = _extends({}, (_objectDestructuringEmpty(_ref36), _ref36));
  return FUtil.Request({
    method: 'GET',
    url: "/v2/resources/catalogues/drafts/items/batch/list",
    params: params
  });
}
function getCollectionUpdateLogs(_ref37) {
  var resourceId = _ref37.resourceId,
    params = _objectWithoutPropertiesLoose(_ref37, _excluded21);
  return FUtil.Request({
    method: 'GET',
    url: "/v2/resources/catalogue/" + resourceId + "/updateLogs",
    params: params
  });
}
function getCollectionCollectRules(_ref38) {
  var resourceId = _ref38.resourceId;
  return FUtil.Request({
    method: 'GET',
    url: "/v2/resources/catalogue/" + resourceId + "/items/collectRules"
  });
}
function setCollectRules(_ref39) {
  var resourceId = _ref39.resourceId,
    params = _objectWithoutPropertiesLoose(_ref39, _excluded22);
  return FUtil.Request({
    method: 'POST',
    url: "/v2/resources/catalogue/" + resourceId + "/items/collectRules",
    data: params
  });
}
function setItemsTitle(_ref40) {
  var resourceId = _ref40.resourceId,
    data = _ref40.data;
  return FUtil.Request({
    method: 'PUT',
    url: "/v2/resources/catalogue/" + resourceId + "/items",
    data: data
  });
}
function deleteCollectionItems_Draft(_ref41) {
  var resourceId = _ref41.resourceId,
    removeCollectionItemIds = _ref41.removeCollectionItemIds;
  return FUtil.Request({
    method: 'DELETE',
    url: "/v2/resources/catalogues/drafts/" + resourceId + "/items?removeCollectionItemIds=" + removeCollectionItemIds.join(',')
  });
}
function setCollectionItemsSortID_Draft(_ref42) {
  var resourceId = _ref42.resourceId,
    data = _ref42.data;
  return FUtil.Request({
    method: 'PUT',
    url: "/v2/resources/catalogues/drafts/" + resourceId + "/manualSort",
    data: data
  });
}
function reorderCollectionItems_Draft(_ref43) {
  var resourceId = _ref43.resourceId,
    params = _objectWithoutPropertiesLoose(_ref43, _excluded23);
  return FUtil.Request({
    method: 'PUT',
    url: "/v2/resources/catalogues/drafts/" + resourceId + "/reorder",
    data: params
  });
}
function resourceIsExistInItems_Draft(_ref44) {
  var resourceId = _ref44.resourceId,
    params = _objectWithoutPropertiesLoose(_ref44, _excluded24);
  return FUtil.Request({
    method: 'GET',
    url: "/v2/resources/catalogues/drafts/" + resourceId + "/items/checkExists",
    params: params
  });
}
function updateCollectionItemsInfo_Draft(_ref45) {
  var resourceId = _ref45.resourceId,
    data = _ref45.data;
  return FUtil.Request({
    method: 'PUT',
    // url: `/v2/resources/catalogue/${resourceId}/items`,
    url: "/v2/resources/catalogues/drafts/" + resourceId + "/items",
    data: data
  });
}
function updateCollectionItemAuthorization_Draft(_ref46) {
  var resourceId = _ref46.resourceId,
    itemId = _ref46.itemId,
    data = _objectWithoutPropertiesLoose(_ref46, _excluded25);
  return FUtil.Request({
    method: 'PUT',
    // url: `/v2/resources/catalogues/${resourceId}/items/${itemId}`,
    url: "/v2/resources/catalogues/drafts/" + resourceId + "/items/" + itemId,
    data: data
  });
}
function addResourceItems_Draft(_ref47) {
  var resourceId = _ref47.resourceId,
    params = _objectWithoutPropertiesLoose(_ref47, _excluded26);
  return FUtil.Request({
    method: 'POST',
    url: "/v2/resources/catalogues/drafts/" + resourceId + "/items",
    data: params
  });
}
function getCollectionItemsAuth_Draft(_ref48) {
  var resourceId = _ref48.resourceId,
    params = _objectWithoutPropertiesLoose(_ref48, _excluded27);
  return FUtil.Request({
    method: 'GET',
    url: "/v2/resources/catalogues/drafts/" + resourceId + "/items/batchAuth",
    params: params
  });
}

var Resource = {
  __proto__: null,
  create: create$1,
  createBatch: createBatch,
  update: update,
  batchUpdate: batchUpdate,
  list: list,
  info: info,
  batchInfo: batchInfo,
  dependencyTree: dependencyTree$1,
  authTree: authTree$1,
  createVersion: createVersion,
  resourceVersionInfo1: resourceVersionInfo1,
  resourceVersionInfo2: resourceVersionInfo2,
  getVersionListByResourceID: getVersionListByResourceID,
  getVersionList: getVersionList,
  getResourceVersionBySha1: getResourceVersionBySha1,
  getResourceBySha1: getResourceBySha1,
  updateResourceVersionInfo: updateResourceVersionInfo,
  saveVersionsDraft: saveVersionsDraft,
  lookDraft: lookDraft,
  deleteResourceDraft: deleteResourceDraft,
  resourceIsUsedByOther: resourceIsUsedByOther,
  resourcesDownload: resourcesDownload,
  batchGetCoverageVersions: batchGetCoverageVersions,
  resolveResources: resolveResources,
  batchSetContracts: batchSetContracts,
  cycleDependencyCheck: cycleDependencyCheck$1,
  relationTree: relationTree$1,
  relationTreeAuth: relationTreeAuth,
  resourcesCount: resourcesCount,
  batchAuth: batchAuth$1,
  resourcesRecommend: resourcesRecommend,
  availableTags: availableTags,
  resourceTypes: resourceTypes$1,
  ListSimpleByParentCode: ListSimpleByParentCode,
  getResourceTypeInfoByCode: getResourceTypeInfoByCode,
  getResourceAttrListSimple: getResourceAttrListSimple,
  listSimple4Recently: listSimple4Recently,
  getAttrsInfoByKey: getAttrsInfoByKey,
  generateResourceNames: generateResourceNames,
  updateCollection: updateCollection,
  deleteCollectionUnitResource: deleteCollectionUnitResource,
  getCollectionItems: getCollectionItems,
  getCollectionItems_Draft: getCollectionItems_Draft,
  setCollectionItemSort: setCollectionItemSort,
  reorderCollectionItemsSort: reorderCollectionItemsSort,
  checkExistCollectionItems: checkExistCollectionItems,
  getCollectionItemsAuth: getCollectionItemsAuth,
  batchResourceItems: batchResourceItems,
  batchResourceItems_Draft: batchResourceItems_Draft,
  getCollectionUpdateLogs: getCollectionUpdateLogs,
  getCollectionCollectRules: getCollectionCollectRules,
  setCollectRules: setCollectRules,
  setItemsTitle: setItemsTitle,
  deleteCollectionItems_Draft: deleteCollectionItems_Draft,
  setCollectionItemsSortID_Draft: setCollectionItemsSortID_Draft,
  reorderCollectionItems_Draft: reorderCollectionItems_Draft,
  resourceIsExistInItems_Draft: resourceIsExistInItems_Draft,
  updateCollectionItemsInfo_Draft: updateCollectionItemsInfo_Draft,
  updateCollectionItemAuthorization_Draft: updateCollectionItemAuthorization_Draft,
  addResourceItems_Draft: addResourceItems_Draft,
  getCollectionItemsAuth_Draft: getCollectionItemsAuth_Draft
};

var _excluded$4 = ["loginName"];
function login$1(_ref) {
  var params = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  // return FUtil.Axios.post(`/v2/passport/login`, params);
  return FUtil.Request({
    method: 'POST',
    url: '/v2/passport/login',
    data: params
  }, {
    noRedirect: true
  });
}
function logout(_temp) {
  var _ref2 = _temp === void 0 ? {} : _temp,
    params = _extends({}, (_objectDestructuringEmpty(_ref2), _ref2));
  return FUtil.Request({
    method: 'GET',
    url: '/v2/passport/logout',
    params: params
  }, {
    noRedirect: true
  });
}
function users(params) {
  return FUtil.Request({
    method: 'GET',
    url: "/v2/users/search",
    params: params
  });
}
function batchUserList(params) {
  return FUtil.Request({
    method: 'GET',
    url: "/v2/users/list",
    params: params
  });
}
function currentUserInfo(_temp2) {
  _objectDestructuringEmpty(_temp2 === void 0 ? {} : _temp2);
  // return FUtil.Axios.get(`/v1/userinfos/current`);
  return FUtil.Request({
    method: 'GET',
    url: '/v2/users/current'
  });
}
function userDetails(params) {
  return FUtil.Request({
    method: 'GET',
    url: "/v2/users/detail",
    params: params
  });
}
function logon$1(params) {
  return FUtil.Request({
    method: 'POST',
    url: '/v2/users',
    data: params
  });
}
function resetPassword(_ref4) {
  var loginName = _ref4.loginName,
    params = _objectWithoutPropertiesLoose(_ref4, _excluded$4);
  return FUtil.Request({
    method: 'PUT',
    url: "/v2/users/" + loginName + "/resetPassword",
    data: params
  });
}
function updatePassword(params) {
  return FUtil.Request({
    method: 'PUT',
    url: "/v2/users/current/updatePassword",
    data: params
  });
}
function uploadHeadImg(params, config) {
  var formData = new FormData();
  for (var _i = 0, _Object$entries = Object.entries(params); _i < _Object$entries.length; _i++) {
    var _Object$entries$_i = _Object$entries[_i],
      key = _Object$entries$_i[0],
      value = _Object$entries$_i[1];
    if (value) {
      formData.append(key, value);
    }
  }
  return FUtil.Request(_extends({
    method: 'POST',
    url: "/v2/users/current/uploadHeadImg",
    data: formData
  }, config));
}
function updateDetailInfo(params) {
  return FUtil.Request({
    method: 'PUT',
    url: "/v2/users/current/detailInfo",
    data: params
  });
}
function verifyLoginPassword(params) {
  return FUtil.Request({
    method: 'GET',
    url: "/v2/users/verifyLoginPassword",
    params: params
  });
}
function areasProvinces(params) {
  if (params === void 0) {
    params = {};
  }
  return FUtil.Request({
    method: 'GET',
    url: "/v2/areas/provinces",
    params: params
  });
}
function updateMobileOrEmail(params) {
  return FUtil.Request({
    method: 'PUT',
    url: "/v2/users/current/mobileOrEmail",
    data: params
  });
}
function registerOrBind(params) {
  return FUtil.Request({
    method: 'POST',
    url: "/v2/thirdParty/registerOrBind",
    data: params
  }, {
    noRedirect: true
  });
}
function thirdPartyUnbind(params) {
  return FUtil.Request({
    method: 'PUT',
    url: "/v2/thirdParty/unbind",
    data: params
  });
}
function thirdPartyList(params) {
  if (params === void 0) {
    params = {};
  }
  return FUtil.Request({
    method: 'GET',
    url: "/v2/thirdParty/list",
    params: params
  });
}
function thirdPartyIsBind(params) {
  return FUtil.Request({
    method: 'GET',
    url: "/v2/thirdParty/isBind",
    params: params
  });
}
// 签到
function signForCoins() {
  return FUtil.Request({
    method: 'GET',
    url: "/v2/activities/facade/sign"
  });
}
// 查询签到信息
function getSignInfo() {
  return FUtil.Request({
    method: 'GET',
    url: "/v2/activities/facade/signInfo"
  });
}
function searchForConsole(params) {
  if (params === void 0) {
    params = {};
  }
  return FUtil.Request({
    method: 'GET',
    url: '/v2/users/searchForConsole',
    params: params
  });
}

var User = {
  __proto__: null,
  login: login$1,
  logout: logout,
  users: users,
  batchUserList: batchUserList,
  currentUserInfo: currentUserInfo,
  userDetails: userDetails,
  logon: logon$1,
  resetPassword: resetPassword,
  updatePassword: updatePassword,
  uploadHeadImg: uploadHeadImg,
  updateDetailInfo: updateDetailInfo,
  verifyLoginPassword: verifyLoginPassword,
  areasProvinces: areasProvinces,
  updateMobileOrEmail: updateMobileOrEmail,
  registerOrBind: registerOrBind,
  thirdPartyUnbind: thirdPartyUnbind,
  thirdPartyList: thirdPartyList,
  thirdPartyIsBind: thirdPartyIsBind,
  signForCoins: signForCoins,
  getSignInfo: getSignInfo,
  searchForConsole: searchForConsole
};

var _excluded$5 = ["nodeId"],
  _excluded2$4 = ["nodeId"],
  _excluded3$4 = ["nodeId"],
  _excluded4$4 = ["nodeId"],
  _excluded5$4 = ["nodeId"],
  _excluded6$3 = ["testResourceId"],
  _excluded7$3 = ["testResourceId"],
  _excluded8$2 = ["nodeId"],
  _excluded9$2 = ["nodeId"],
  _excluded10$2 = ["nodeId"],
  _excluded11$2 = ["nodeId"];
function testResources(_ref) {
  var nodeId = _ref.nodeId,
    params = _objectWithoutPropertiesLoose(_ref, _excluded$5);
  return FUtil.Request({
    method: 'GET',
    url: "/v2/testNodes/" + nodeId + "/testResources",
    params: params
  });
}
function createRules(_ref2) {
  var nodeId = _ref2.nodeId,
    params = _objectWithoutPropertiesLoose(_ref2, _excluded2$4);
  return FUtil.Request({
    method: 'POST',
    url: "/v2/testNodes/" + nodeId + "/rules",
    data: params
  });
}
function batchTestResources(_ref3) {
  var nodeId = _ref3.nodeId,
    params = _objectWithoutPropertiesLoose(_ref3, _excluded3$4);
  return FUtil.Request({
    method: 'GET',
    url: "/v2/testNodes/" + nodeId + "/testResources/list",
    params: params
  });
}
function dependencyTree$2(_ref4) {
  var nodeId = _ref4.nodeId,
    params = _objectWithoutPropertiesLoose(_ref4, _excluded4$4);
  return FUtil.Request({
    method: 'GET',
    url: "/v2/testNodes/" + nodeId + "/testResources/dependencyTree/search",
    params: params
  });
}
function putRules(_ref5) {
  var nodeId = _ref5.nodeId,
    params = _objectWithoutPropertiesLoose(_ref5, _excluded5$4);
  return FUtil.Request({
    method: 'PUT',
    url: "/v2/testNodes/" + nodeId + "/rules",
    data: params
  });
}
function testNodeRules(_ref6) {
  var nodeId = _ref6.nodeId;
  return FUtil.Request({
    method: 'GET',
    url: "/v2/testNodes/" + nodeId + "/rules"
  });
}
function updateTestResourceContracts(_ref7) {
  var testResourceId = _ref7.testResourceId,
    params = _objectWithoutPropertiesLoose(_ref7, _excluded6$3);
  // return FUtil.Axios.put(`/v2/testNodes/testResources/${testResourceId}`, params);
  return FUtil.Request({
    method: 'PUT',
    url: "/v2/testNodes/testResources/" + testResourceId,
    data: params
  });
}
function dependencyTreeFilter(_ref8) {
  var testResourceId = _ref8.testResourceId,
    params = _objectWithoutPropertiesLoose(_ref8, _excluded7$3);
  // return FUtil.Axios.get(`/v2/testNodes/testResources/${testResourceId}/dependencyTree/filter`, {
  //   params
  // });
  return FUtil.Request({
    method: 'GET',
    url: "/v2/testNodes/testResources/" + testResourceId + "/dependencyTree/filter",
    params: params
  });
}
function testResourcesDependencyTree(_ref9) {
  var testResourceId = _ref9.testResourceId;
  return FUtil.Request({
    method: 'GET',
    url: "/v2/testNodes/testResources/" + testResourceId + "/dependencyTree"
  });
}
function testResourcesAuthTree(_ref10) {
  var testResourceId = _ref10.testResourceId;
  // return FUtil.Axios.get(`/v2/testNodes/testResources/${testResourceId}`);
  return FUtil.Request({
    method: 'GET',
    url: "/v2/testNodes/testResources/" + testResourceId + "/authTree"
  });
}
function testResourceDetails(_ref11) {
  var testResourceId = _ref11.testResourceId;
  // return FUtil.Axios.get(`/v2/testNodes/testResources/${testResourceId}`);
  return FUtil.Request({
    method: 'GET',
    url: "/v2/testNodes/testResources/" + testResourceId
  });
}
function searchTestResourcesByDependency(_ref12) {
  var nodeId = _ref12.nodeId,
    params = _objectWithoutPropertiesLoose(_ref12, _excluded8$2);
  // return FUtil.Axios.get(`/v2/testNodes/${nodeId}/testResources/searchByDependency`, {
  //   params,
  // });
  return FUtil.Request({
    method: 'GET',
    url: "/v2/testNodes/" + nodeId + "/testResources/searchByDependency",
    params: params
  });
}
function rulesRematch(_ref13) {
  var nodeId = _ref13.nodeId,
    params = _objectWithoutPropertiesLoose(_ref13, _excluded9$2);
  return FUtil.Request({
    method: 'POST',
    url: "/v2/testNodes/" + nodeId + "/rules/rematch",
    data: params
  });
}
function rulesPreExecution(_ref14) {
  var nodeId = _ref14.nodeId,
    params = _objectWithoutPropertiesLoose(_ref14, _excluded10$2);
  return FUtil.Request({
    method: 'POST',
    url: "/v2/testNodes/" + nodeId + "/rules/preExecution",
    data: params
  });
}
function batchGetAuths(_ref15) {
  var nodeId = _ref15.nodeId,
    params = _objectWithoutPropertiesLoose(_ref15, _excluded11$2);
  return FUtil.Request({
    method: 'GET',
    url: "/v2/auths/exhibits/" + nodeId + "/test/batchAuth/results",
    params: params
  });
}

var InformalNode = {
  __proto__: null,
  testResources: testResources,
  createRules: createRules,
  batchTestResources: batchTestResources,
  dependencyTree: dependencyTree$2,
  putRules: putRules,
  testNodeRules: testNodeRules,
  updateTestResourceContracts: updateTestResourceContracts,
  dependencyTreeFilter: dependencyTreeFilter,
  testResourcesDependencyTree: testResourcesDependencyTree,
  testResourcesAuthTree: testResourcesAuthTree,
  testResourceDetails: testResourceDetails,
  searchTestResourcesByDependency: searchTestResourcesByDependency,
  rulesRematch: rulesRematch,
  rulesPreExecution: rulesPreExecution,
  batchGetAuths: batchGetAuths
};

var _excluded$6 = ["contractId"],
  _excluded2$5 = ["contractId"];
function createContract(_ref) {
  var params = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  return FUtil.Request({
    method: 'POST',
    url: "/v2/contracts",
    data: params
  });
}
function batchCreateContracts(_ref2) {
  var params = _extends({}, (_objectDestructuringEmpty(_ref2), _ref2));
  return FUtil.Request({
    method: 'POST',
    url: "/v2/contracts/batchSign",
    data: params
  });
}
function contractDetails(_ref3) {
  var contractId = _ref3.contractId,
    params = _objectWithoutPropertiesLoose(_ref3, _excluded$6);
  return FUtil.Request({
    method: 'GET',
    url: "/v2/contracts/" + contractId,
    params: params
  });
}
function contracts(params) {
  return FUtil.Request({
    method: 'GET',
    url: "/v2/contracts",
    params: params
  });
}
function keywordSuggest(params) {
  return FUtil.Request({
    method: 'GET',
    url: "/v2/contracts/keywordSuggest",
    params: params
  });
}
function batchContracts(params) {
  return FUtil.Request({
    method: 'GET',
    url: "/v2/contracts/list",
    params: params
  });
}
function transitionRecords(_ref4) {
  var contractId = _ref4.contractId,
    params = _objectWithoutPropertiesLoose(_ref4, _excluded2$5);
  return FUtil.Request({
    method: 'GET',
    url: "/v2/contracts/" + contractId + "/transitionRecords",
    params: params
  });
}
function contractsSignCount(params) {
  return FUtil.Request({
    method: 'GET',
    url: "/v2/contracts/signCount",
    params: params
  });
}

var Contract = {
  __proto__: null,
  createContract: createContract,
  batchCreateContracts: batchCreateContracts,
  contractDetails: contractDetails,
  contracts: contracts,
  keywordSuggest: keywordSuggest,
  batchContracts: batchContracts,
  transitionRecords: transitionRecords,
  contractsSignCount: contractsSignCount
};

var _excluded$7 = ["accountId"],
  _excluded2$6 = ["userId"];
function details$1(_ref) {
  var accountId = _ref.accountId,
    params = _objectWithoutPropertiesLoose(_ref, _excluded$7);
  return FUtil.Request({
    method: 'GET',
    url: "/v2/transactions/details/" + accountId,
    params: params
  });
}
function individualAccounts(_ref2) {
  var userId = _ref2.userId,
    params = _objectWithoutPropertiesLoose(_ref2, _excluded2$6);
  return FUtil.Request({
    method: 'GET',
    url: "/v2/accounts/individualAccounts/" + userId,
    params: params
  });
}
function transactionDetails(_ref3) {
  var recordId = _ref3.recordId;
  return FUtil.Request({
    method: 'GET',
    url: "/v2/transactions/records/" + recordId
  });
}
function activateIndividualAccounts(_ref4) {
  var params = _extends({}, (_objectDestructuringEmpty(_ref4), _ref4));
  return FUtil.Request({
    method: 'PUT',
    url: "/v2/accounts/individualAccounts/activate",
    data: params
  });
}
function changePassword(_ref5) {
  var params = _extends({}, (_objectDestructuringEmpty(_ref5), _ref5));
  return FUtil.Request({
    method: 'PUT',
    url: "/v2/accounts/individualAccounts",
    data: params
  });
}
function resetPassword$1(_ref6) {
  var params = _extends({}, (_objectDestructuringEmpty(_ref6), _ref6));
  return FUtil.Request({
    method: 'PUT',
    url: "/v2/accounts/individualAccounts/resetPassword",
    data: params
  });
}
function verifyTransactionPassword(_ref7) {
  var params = _extends({}, (_objectDestructuringEmpty(_ref7), _ref7));
  return FUtil.Request({
    method: 'GET',
    url: "/v2/accounts/individualAccounts/verifyTransactionPassword",
    params: params
  });
}

var Transaction = {
  __proto__: null,
  details: details$1,
  individualAccounts: individualAccounts,
  transactionDetails: transactionDetails,
  activateIndividualAccounts: activateIndividualAccounts,
  changePassword: changePassword,
  resetPassword: resetPassword$1,
  verifyTransactionPassword: verifyTransactionPassword
};

function sendVerificationCode(params) {
  return FUtil.Request({
    method: 'POST',
    url: "/v2/messages/send",
    data: params
  });
}
function verifyVerificationCode(params) {
  return FUtil.Request({
    method: 'GET',
    url: "/v2/messages/verify",
    params: params
  });
}

var Captcha = {
  __proto__: null,
  sendVerificationCode: sendVerificationCode,
  verifyVerificationCode: verifyVerificationCode
};

var _excluded$8 = ["contractId"];
function transaction(_ref) {
  var contractId = _ref.contractId,
    params = _objectWithoutPropertiesLoose(_ref, _excluded$8);
  return FUtil.Request({
    method: 'POST',
    url: "/v2/contracts/" + contractId + "/events/payment",
    data: params
  });
}

var Event = {
  __proto__: null,
  transaction: transaction
};

function list4Client(params) {
  return FUtil.Request({
    method: 'GET',
    url: "/v2/activities/list4Client",
    params: params
  });
}
function find4Client(params) {
  return FUtil.Request({
    method: 'GET',
    url: "/v2/activities/find4Client",
    params: params
  });
}
function adsList(params) {
  return FUtil.Request({
    method: 'GET',
    url: "/v2/activities/ads/list4Client",
    params: params
  });
}
function adsDetails(params) {
  return FUtil.Request({
    method: 'GET',
    url: "/v2/activities/ads/find4Client",
    params: params
  });
}
function eventTrackingAdsVisit(params) {
  return FUtil.Request({
    method: 'GET',
    url: "/v2/activities/ads/visit",
    params: params
  });
}
function eventTrackingAdsClick(params) {
  return FUtil.Request({
    method: 'GET',
    url: "/v2/activities/ads/click",
    params: params
  });
}
function getBaseTaskInfo(params) {
  if (params === void 0) {
    params = {};
  }
  return FUtil.Request({
    method: 'GET',
    url: "/v2/activities/facade/getBaseTaskInfo",
    params: params
  });
}
function getResourceTaskInfo(params) {
  if (params === void 0) {
    params = {};
  }
  return FUtil.Request({
    method: 'GET',
    url: "/v2/activities/facade/getResourceTaskInfo",
    params: params
  });
}
function getNodeTaskInfo(params) {
  if (params === void 0) {
    params = {};
  }
  return FUtil.Request({
    method: 'GET',
    url: "/v2/activities/facade/getNodeTaskInfo",
    params: params
  });
}
function getRewardRecordInfo(params) {
  return FUtil.Request({
    method: 'GET',
    url: "/v2/activities/facade/getRewardRecordInfo",
    params: params
  });
}
function pushMessageTask(params) {
  return FUtil.Request({
    method: 'POST',
    url: "/v2/activities/facade/pushMessage4Task",
    data: params
  });
}
function getCoinAccount(params) {
  return FUtil.Request({
    method: 'GET',
    url: "/v2/activities/coin/account/find4Client",
    params: params
  });
}
function withdrawCoinAccount(params) {
  return FUtil.Request({
    method: 'POST',
    url: "/v2/activities/coin/account/cash4Client",
    data: params
  });
}
function getCoinAccountRecords(params) {
  return FUtil.Request({
    method: 'GET',
    url: "/v2/activities/coin/record/list4Client",
    params: params
  });
}
function getWechatOfficialAccountInfo(params) {
  if (params === void 0) {
    params = {};
  }
  return FUtil.Request({
    method: 'GET',
    url: "/v2/extensions/wechat/getRelationship4Client",
    params: params
  });
}
function lotteryList(params) {
  if (params === void 0) {
    params = {};
  }
  return FUtil.Request({
    method: 'GET',
    url: "/v2/activities/lottery/resource/list",
    params: params
  });
}
function lotteryShow(params) {
  return FUtil.Request({
    method: 'GET',
    url: "/v2/activities/lottery/resource/show",
    params: params
  });
}
function listInviteFriendInfos(params) {
  return FUtil.Request({
    method: 'POST',
    url: "/v2/activities/facade/listInviteFriendInfos",
    data: params
  });
}
function getRewardRecordInfos(params) {
  return FUtil.Request({
    method: 'POST',
    url: "/v2/activities/facade/getRewardRecordInfos",
    data: params
  });
}
function listRewardRecordInfos(params) {
  if (params === void 0) {
    params = {};
  }
  return FUtil.Request({
    method: 'POST',
    url: "/v2/activities/facade/listRewardRecordInfos",
    data: params
  });
}
function statisticRewardRecords(params) {
  return FUtil.Request({
    method: 'POST',
    url: "/v2/activities/facade/statisticRewardRecords",
    data: params
  });
}
function statisticTaskRecords(params) {
  return FUtil.Request({
    method: 'POST',
    url: "/v2/activities/facade/statisticTaskRecords",
    data: params
  });
}
function statisticSingleRewardRecordForAll(params) {
  return FUtil.Request({
    method: 'POST',
    url: "/v2/activities/facade/statisticSingleRewardRecordForAll",
    data: params
  });
}

var Activity = {
  __proto__: null,
  list4Client: list4Client,
  find4Client: find4Client,
  adsList: adsList,
  adsDetails: adsDetails,
  eventTrackingAdsVisit: eventTrackingAdsVisit,
  eventTrackingAdsClick: eventTrackingAdsClick,
  getBaseTaskInfo: getBaseTaskInfo,
  getResourceTaskInfo: getResourceTaskInfo,
  getNodeTaskInfo: getNodeTaskInfo,
  getRewardRecordInfo: getRewardRecordInfo,
  pushMessageTask: pushMessageTask,
  getCoinAccount: getCoinAccount,
  withdrawCoinAccount: withdrawCoinAccount,
  getCoinAccountRecords: getCoinAccountRecords,
  getWechatOfficialAccountInfo: getWechatOfficialAccountInfo,
  lotteryList: lotteryList,
  lotteryShow: lotteryShow,
  listInviteFriendInfos: listInviteFriendInfos,
  getRewardRecordInfos: getRewardRecordInfos,
  listRewardRecordInfos: listRewardRecordInfos,
  statisticRewardRecords: statisticRewardRecords,
  statisticTaskRecords: statisticTaskRecords,
  statisticSingleRewardRecordForAll: statisticSingleRewardRecordForAll
};

var _excluded$9 = ["recordId"];
function codeDetails1(_ref) {
  var code = _ref.code;
  return FUtil.Request({
    method: 'GET',
    url: "/v2/testQualifications/beta/codes/" + code
  });
}
function codeDetails2(_ref2) {
  _objectDestructuringEmpty(_ref2);
  return FUtil.Request({
    method: 'GET',
    url: "/v2/testQualifications/beta/codes/userActivateCode"
  });
}
function betaCodesActivate(_ref3) {
  var params = _extends({}, (_objectDestructuringEmpty(_ref3), _ref3));
  return FUtil.Request({
    method: 'POST',
    url: "/v2/testQualifications/beta/codes/activate",
    data: params
  });
}
function usedRecords(_ref4) {
  var params = _extends({}, (_objectDestructuringEmpty(_ref4), _ref4));
  return FUtil.Request({
    method: 'GET',
    url: "/v2/testQualifications/beta/codes/usedRecords",
    params: params
  });
}
function betaApply(_ref5) {
  var params = _extends({}, (_objectDestructuringEmpty(_ref5), _ref5));
  return FUtil.Request({
    method: 'POST',
    url: "/v2/testQualifications/beta/apply",
    data: params
  });
}
function getBetaApply1(_temp) {
  var _ref6 = _temp === void 0 ? {} : _temp,
    params = _extends({}, (_objectDestructuringEmpty(_ref6), _ref6));
  return FUtil.Request({
    method: 'GET',
    url: "/v2/testQualifications/beta/apply/current",
    params: params
  });
}
function getBetaApply2(_ref7) {
  var recordId = _ref7.recordId,
    params = _objectWithoutPropertiesLoose(_ref7, _excluded$9);
  return FUtil.Request({
    method: 'GET',
    url: "/v2/testQualifications/beta/apply/" + recordId,
    params: params
  });
}
function invitees(_ref8) {
  var params = _extends({}, (_objectDestructuringEmpty(_ref8), _ref8));
  return FUtil.Request({
    method: 'GET',
    url: "/v2/testQualifications/beta/codes/invitees",
    params: params
  });
}

var TestQualification = {
  __proto__: null,
  codeDetails1: codeDetails1,
  codeDetails2: codeDetails2,
  betaCodesActivate: betaCodesActivate,
  usedRecords: usedRecords,
  betaApply: betaApply,
  getBetaApply1: getBetaApply1,
  getBetaApply2: getBetaApply2,
  invitees: invitees
};

function transactionsCommon(params) {
  return FUtil.Request({
    method: 'GET',
    url: "/v2/statistics/transactions/common",
    params: params
  });
}

var Statistic = {
  __proto__: null,
  transactionsCommon: transactionsCommon
};

function configsList(params) {
  // console.log('####@30984i2o3jdsjflfkjsdl')
  return FUtil.Request({
    method: 'POST',
    url: "/v2/i18n/configs/list",
    data: params
  });
}
// oss保存的翻译
// interface ConfigsListParamsType {
//   key: string;
//   content: string;
//   tagIds: string[];
//   status: 0 | 1 | 2 | 3; // 0：全部 1：待翻译 2：待发布 3：已发布
// }
//
// export function configsList(params: ConfigsListParamsType) {
//   // console.log('####@30984i2o3jdsjflfkjsdl')
//   return FUtil.Request({
//     method: 'POST',
//     url: `/v2/i18n/configs/list`,
//     data: params,
//   });
// }

var I18n = {
  __proto__: null,
  configsList: configsList
};

// import {Base64} from 'js-base64';
function policies(params) {
  return FUtil.Request({
    method: 'GET',
    url: "/v2/policies",
    params: params
  });
}
function policiesList(params) {
  return FUtil.Request({
    method: 'GET',
    url: "/v2/policies/list",
    params: params
  });
}
function policyTemplates(params) {
  if (params === void 0) {
    params = {};
  }
  return FUtil.Request({
    method: 'GET',
    url: "/v2/translate/translate-config/list4Client",
    params: params
  });
}
function policyTranslation(_ref) {
  var contract = _ref.contract;
  return FUtil.Request({
    method: 'POST',
    url: "/v2/translate/translate",
    data: {
      contract: contract
    }
  });
}
function policyTransferTranslation(params) {
  return FUtil.Request({
    method: 'POST',
    url: "/v2/translate/transfer",
    data: params
  });
}

var Policy = {
  __proto__: null,
  policies: policies,
  policiesList: policiesList,
  policyTemplates: policyTemplates,
  policyTranslation: policyTranslation,
  policyTransferTranslation: policyTransferTranslation
};

// import * as CryptoJS from 'crypto-js';
/**
 * 根据 File 获取 SHA1 Hash 字符串
 * @param file
 * @return {Promise<string>}
 */
function getSHA1Hash(file) {
  return new Promise(function (resolve) {
    var reader = new FileReader();
    reader.readAsArrayBuffer(file);
    reader.onload = /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var sha1;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (reader.result) {
              _context.next = 3;
              break;
            }
            resolve('');
            return _context.abrupt("return", '');
          case 3:
            if (!(typeof reader.result === 'string')) {
              _context.next = 6;
              break;
            }
            resolve('');
            return _context.abrupt("return", '');
          case 6:
            _context.next = 8;
            return self.crypto.subtle.digest('SHA-1', reader.result).then(function (a) {
              return Array.from(new Uint8Array(a)).map(function (a) {
                return a.toString(16).padStart(2, '0');
              }).join('');
            });
          case 8:
            sha1 = _context.sent;
            resolve(sha1);
            return _context.abrupt("return", '');
          case 11:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
  });
}
/**
 * 生成随机码
 */
function generateRandomCode(strLen) {
  if (strLen === void 0) {
    strLen = 5;
  }
  var allStr = 'ABCDEFGHIJKLMNPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz1234567890';
  var newStrArr = [];
  for (var i = 0; i < strLen; i++) {
    newStrArr.push(allStr[Math.floor(Math.random() * 61)]);
  }
  return newStrArr.join('');
}
/**
 * 通过读取 cookies 获取用户 ID
 */
function getUserIDByCookies() {
  var uid = document.cookie.split('; ').find(function (co) {
    return co.startsWith('uid=');
  });
  if (!uid) {
    return -1;
  }
  return Number(uid.replace('uid=', ''));
}
function transformServerAPIContractState(_ref2) {
  var status = _ref2.status,
    authStatus = _ref2.authStatus;
  if (status === 0) {
    if (authStatus === 1 || authStatus === 3) {
      return 'active';
    }
    if (authStatus === 2) {
      return 'testActive';
    }
    if (authStatus === 128) {
      return 'inactive';
    }
  }
  if (status === 1) {
    return 'terminal';
  }
  return 'exception';
}
/**
 * 暂时休眠
 * @param ms 休眠时常(毫秒)
 */
function promiseSleep(ms) {
  if (ms === void 0) {
    ms = 300;
  }
  return new Promise(function (resolve) {
    setTimeout(function () {
      resolve();
    }, ms);
  });
}
/**
 * 获取用户头像URL
 * @param userID
 */
function getAvatarUrl(userID) {
  if (userID === void 0) {
    userID = 0;
  }
  // return `${completeUrlByDomain('image')}/avatar/${userID || getUserIDByCookies()}?t=${Date.now()}`;
  return "https://image.freelog.com/avatar/" + (userID || getUserIDByCookies()) + "?t=" + Date.now();
}

var Tool = {
  __proto__: null,
  getSHA1Hash: getSHA1Hash,
  generateRandomCode: generateRandomCode,
  getUserIDByCookies: getUserIDByCookies,
  transformServerAPIContractState: transformServerAPIContractState,
  promiseSleep: promiseSleep,
  getAvatarUrl: getAvatarUrl
};

function getFilesSha1Info(_x, _x2) {
  return _getFilesSha1Info.apply(this, arguments);
}
function _getFilesSha1Info() {
  _getFilesSha1Info = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(_ref, cdPartially) {
    var sha1, resourceTypeCode, delay, needHandleSha1, allData, _yield$Storage$filesL, ret, errCode, data, msg, finishedInfo;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          sha1 = _ref.sha1, resourceTypeCode = _ref.resourceTypeCode;
          if (cdPartially === void 0) {
            cdPartially = function cdPartially() {
              return undefined;
            };
          }
          if (!(sha1.length === 0)) {
            _context.next = 4;
            break;
          }
          return _context.abrupt("return", {
            error: '',
            result: []
          });
        case 4:
          delay = 500;
          needHandleSha1 = [].concat(sha1);
          allData = [];
        case 7:
          _context.next = 10;
          return filesListInfo({
            sha1: needHandleSha1.join(','),
            resourceTypeCode: resourceTypeCode
          });
        case 10:
          _yield$Storage$filesL = _context.sent;
          ret = _yield$Storage$filesL.ret;
          errCode = _yield$Storage$filesL.errCode;
          data = _yield$Storage$filesL.data;
          msg = _yield$Storage$filesL.msg;
          if (!(ret !== 0 || errCode !== 0)) {
            _context.next = 18;
            break;
          }
          console.log({
            ret: ret,
            errCode: errCode,
            data: data,
            msg: msg
          }, '09iowksdjaklfjs;oalijflskdjflsdkjflkj');
          return _context.abrupt("return", {
            error: msg,
            result: allData
          });
        case 18:
          needHandleSha1 = data.filter(function (d) {
            return d.metaAnalyzeStatus === 0 || d.metaAnalyzeStatus === 1;
          }).map(function (d) {
            return d.sha1;
          });
          finishedInfo = data.filter(function (d) {
            return d.metaAnalyzeStatus !== 0 && d.metaAnalyzeStatus !== 1;
          }).map(function (d) {
            var state = 'fail';
            if (!d.metaAnalyzeStatus) {
              state = 'nonentity';
            } else if (d.metaAnalyzeStatus === 2) {
              state = 'success';
            } else if (d.metaAnalyzeStatus === 3) {
              state = 'fail';
            }
            // console.log(d, '90wieojiksdjf;lkasdjf;lksdjflksjdflkjsdlfkjsdlkj');
            return {
              sha1: d.sha1,
              state: state,
              info: d
            };
          });
          cdPartially && cdPartially(finishedInfo);
          allData = [].concat(allData, finishedInfo);
          if (!(needHandleSha1.length === 0)) {
            _context.next = 24;
            break;
          }
          return _context.abrupt("break", 28);
        case 24:
          _context.next = 26;
          return promiseSleep(delay);
        case 26:
          _context.next = 7;
          break;
        case 28:
          return _context.abrupt("return", {
            error: '',
            result: allData
          });
        case 29:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _getFilesSha1Info.apply(this, arguments);
}

var recombination = {
  __proto__: null,
  getFilesSha1Info: getFilesSha1Info
};

function operationCategories(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
    params = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  return FUtil.Request({
    method: 'GET',
    url: "/v2/resources/operation-categories/listSimpleByGroup",
    params: params
  });
}
function recordRank(_ref2) {
  var params = _extends({}, (_objectDestructuringEmpty(_ref2), _ref2));
  return FUtil.Request({
    method: 'POST',
    url: "/v2/activities/coin/record/rank",
    data: params
  });
}
function rankInfo(_ref3) {
  var params = _extends({}, (_objectDestructuringEmpty(_ref3), _ref3));
  return FUtil.Request({
    method: 'POST',
    url: "/v2/activities/coin/record/rankInfo",
    data: params
  });
}

var Operation = {
  __proto__: null,
  operationCategories: operationCategories,
  recordRank: recordRank,
  rankInfo: rankInfo
};

function getInfoByCode(_ref) {
  var params = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  return FUtil.Request({
    method: 'GET',
    url: "/v2/resources/types/getInfoByCode",
    params: params
  });
}
function getInfoByCodeOrName(_ref2) {
  var params = _extends({}, (_objectDestructuringEmpty(_ref2), _ref2));
  return FUtil.Request({
    method: 'GET',
    url: "/v2/resources/types/getInfoByCodeOrName",
    params: params
  });
}

var ResourceType = {
  __proto__: null,
  getInfoByCode: getInfoByCode,
  getInfoByCodeOrName: getInfoByCodeOrName
};

var FServiceAPI = {
  Node: Node,
  Exhibit: Exhibit,
  Storage: Storage,
  Collection: Collection,
  Resource: Resource,
  User: User,
  InformalNode: InformalNode,
  Contract: Contract,
  Transaction: Transaction,
  Captcha: Captcha,
  Event: Event,
  Activity: Activity,
  TestQualification: TestQualification,
  Statistic: Statistic,
  I18n: I18n,
  Policy: Policy,
  recombination: recombination,
  Operation: Operation,
  ResourceType: ResourceType
};

// import  from '../service-API';
var codeMessage = {
  200: '服务器成功返回请求的数据。',
  201: '新建或修改数据成功。',
  202: '一个请求已经进入后台排队（异步任务）。',
  204: '删除数据成功。',
  400: '发出的请求有错误，服务器没有进行新建或修改数据的操作。',
  401: '用户没有权限（令牌、用户名、密码错误）。',
  403: '用户得到授权，但是访问是被禁止的。',
  404: '发出的请求针对的是不存在的记录，服务器没有进行操作。',
  406: '请求的格式不可得。',
  410: '请求的资源被永久删除，且不会再得到的。',
  422: '当创建一个对象时，发生一个验证错误。',
  500: '服务器发生错误，请检查服务器。',
  502: '网关错误。',
  503: '服务不可用，服务器暂时过载或维护。',
  504: '网关超时。'
};
// export let apiHost: string = '';
if (window.location.hostname.includes('.com')) {
  // apiHost = `${window.location.protocol}//qi.${(window.location.host.match(/(?<=\.).*/) || [''])[0]}`;
  // apiHost = window.location.origin.replace('console', 'qi');
  axios.defaults.withCredentials = true;
  axios.defaults.baseURL = /*#__PURE__*/completeUrlByDomain('api');
}
/**
 * 异常处理程序
 */
// const errorHandler = (error: { response: Response }): Response => {
//   const {response} = error;
//   if (response && response.status) {
//     const errorText = codeMessage[response.status] || response.statusText;
//     const {status, url} = response;
//
//     // notification.error({
//     //   message: `请求错误 ${status}: ${url}`,
//     //   description: errorText,
//     // });
//   } else if (!response) {
//     // notification.error({
//     //   description: '您的网络发生异常，无法连接服务器',
//     //   message: '网络异常',
//     // });
//   }
//   return response;
// };
//
// // Add a request interceptor
axios.interceptors.request.use(function (config) {
  // Do something before request is sent
  // NProgress.start();
  return config;
}, function (error) {
  // Do something with request error
  // NProgress.done();
  return Promise.reject(error);
});
/**
 * 配置request请求时的默认参数
 */
axios.interceptors.response.use(function (response) {
  var _headers$contentDisp;
  // Do something with response data
  // console.log(response, 'response!!!!!!');
  // NProgress.done();
  if (response.status !== 200) {
    var error = {
      description: codeMessage[response.status],
      message: response.status
    };
    // notification.error(error);
    throw new Error(JSON.stringify(error));
  }
  var data = response.data,
    headers = response.headers;
  if ((_headers$contentDisp = headers['content-disposition']) != null && _headers$contentDisp.includes('attachment;')) {
    // downloadFile(response);
    return;
  }
  // console.log(data, 'data2390jasdflkf');
  // if ((data.errcode === undefined
  //   ? (data.errCode !== 0 && data.errCode !== 2)
  //   : (data.errcode !== 0 && data.errcode !== 2))
  //   || data.ret !== 0) {
  //
  //   // notification.error({
  //   //   message: data.msg,
  //   // });
  //   throw new Error(JSON.stringify(data));
  // }
  return data;
}, function (error) {
  // Do something with response error
  // NProgress.done();
  return Promise.reject(error);
});
function request(_x, _x2) {
  return _request.apply(this, arguments);
}
function _request() {
  _request = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(config, _temp) {
    var _ref, _ref$noRedirect, noRedirect, _ref$noErrorAlert, noErrorAlert, result;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _ref = _temp === void 0 ? {} : _temp, _ref$noRedirect = _ref.noRedirect, noRedirect = _ref$noRedirect === void 0 ? false : _ref$noRedirect, _ref$noErrorAlert = _ref.noErrorAlert, noErrorAlert = _ref$noErrorAlert === void 0 ? false : _ref$noErrorAlert;
          _context.next = 3;
          return axios.request(config);
        case 3:
          result = _context.sent;
          if (!(result.errCode === 30 && !noRedirect)) {
            _context.next = 10;
            break;
          }
          _context.next = 7;
          return FServiceAPI.User.logout();
        case 7:
          window.location.replace("" + completeUrlByDomain('user') + login({
            goTo: window.location.href
          }));
          _context.next = 11;
          break;
        case 10:
          if (result.ret === 4 && result.errCode === 10 && !noRedirect) {
            window.location.replace("" + completeUrlByDomain('user') + userFreeze({
              goTo: window.location.href
            }));
          }
        case 11:
          return _context.abrupt("return", result);
        case 12:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _request.apply(this, arguments);
}

function useGetState(initVal) {
  var _React$useState = useState(initVal),
    state = _React$useState[0],
    setState = _React$useState[1];
  var ref = useRef(initVal);
  function setStateCopy(newVal) {
    ref.current = newVal;
    setState(newVal);
  }
  function getState() {
    return ref.current;
  }
  return [state, setStateCopy, getState];
}

var Hook = {
  __proto__: null,
  useGetState: useGetState
};

// import I18n from '../i18n';
var FUtil = {
  Format: Format,
  Regexp: Regexp,
  LinkTo: LinkTo,
  Predefined: Predefined,
  Axios: axios,
  Request: request,
  Tool: Tool,
  Hook: Hook
};

var ossJsonUrl = 'https://freelog-i18n.oss-cn-shenzhen.aliyuncs.com/configs/i18n.json';
var ossJsonUrl_Test = 'https://freelog-i18n.oss-cn-shenzhen.aliyuncs.com/configs-test/i18n.json';
var localStorage_i18nextLng_key = 'locale';
var localStorage_i18nextResources_key = 'i18nextResources';
var allLanguage = [{
  value: 'en_US',
  label: 'English'
}, {
  value: 'zh_CN',
  label: '简体中文'
}];
var I18nNext = /*#__PURE__*/function () {
  function I18nNext() {
    this._loadingData = 'NotStart';
    this._taskQueue = [];
    // private _currentLanguage: LanguageKeyType = window.localStorage.getItem(localStorage_i18nextLng_key) as null || 'zh_CN';
    this._currentLanguage = Cookies.get(localStorage_i18nextLng_key) || 'zh_CN';
    this.ready();
    this.ready = this.ready.bind(this);
    this.t = this.t.bind(this);
    this.changeLanguage = this.changeLanguage.bind(this);
    this.getAllLanguage = this.getAllLanguage.bind(this);
    this.getCurrentLanguage = this.getCurrentLanguage.bind(this);
  }
  var _proto = I18nNext.prototype;
  _proto.ready = /*#__PURE__*/function () {
    var _ready = /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      var _this = this;
      var exc, handleTasks, promise;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            exc = function exc() {
              while (_this._taskQueue.length > 0) {
                var task = _this._taskQueue.shift();
                task && task();
              }
            };
            handleTasks = /*#__PURE__*/function () {
              var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
                return _regeneratorRuntime().wrap(function _callee$(_context) {
                  while (1) switch (_context.prev = _context.next) {
                    case 0:
                      if (!(_this._loadingData === 'End')) {
                        _context.next = 3;
                        break;
                      }
                      exc();
                      return _context.abrupt("return");
                    case 3:
                      if (!(_this._loadingData === 'Start')) {
                        _context.next = 5;
                        break;
                      }
                      return _context.abrupt("return");
                    case 5:
                      // NO_START
                      _this._loadingData = 'Start';
                      _context.next = 8;
                      return _this._handleData();
                    case 8:
                      // console.log('######');
                      exc();
                    case 9:
                    case "end":
                      return _context.stop();
                  }
                }, _callee);
              }));
              return function handleTasks() {
                return _ref.apply(this, arguments);
              };
            }();
            promise = new Promise(function (resolve) {
              _this._taskQueue.push(resolve);
            });
            handleTasks();
            return _context2.abrupt("return", promise);
          case 5:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    function ready() {
      return _ready.apply(this, arguments);
    }
    return ready;
  }();
  _proto.t = function t(key, options) {
    return i18next.t(key.trim(), options);
  };
  _proto.tJSXElement = function tJSXElement(key, options) {
    return htmlReactParser(i18next.t(key.trim(), options));
  };
  _proto.changeLanguage = function changeLanguage(lng) {
    // return i18next.changeLanguage(lng);
    // window.localStorage.setItem(localStorage_i18nextLng_key, lng)
    Cookies.set(localStorage_i18nextLng_key, lng, {
      expires: 36525,
      domain: FUtil.Format.completeUrlByDomain('').replace(/http(s)?:\/\//, '')
    });
  };
  _proto.getAllLanguage = function getAllLanguage() {
    return allLanguage;
  };
  _proto.getCurrentLanguage = function getCurrentLanguage() {
    return this._currentLanguage;
  };
  _proto._handleData = /*#__PURE__*/function () {
    var _handleData2 = /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
      var lng, resource, i18nextResources;
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            lng = this._currentLanguage;
            resource = window.localStorage.getItem(localStorage_i18nextResources_key); // const resource: string | undefined = Cookies.get(decodeURIComponent(localStorage_i18nextResources_key));
            i18nextResources = resource ? JSON.parse(resource) : null;
            if (i18nextResources) {
              _context3.next = 9;
              break;
            }
            _context3.next = 6;
            return this._fetchData();
          case 6:
            i18nextResources = _context3.sent;
            _context3.next = 10;
            break;
          case 9:
            this._fetchData();
          case 10:
            _context3.next = 12;
            return i18next.init({
              // the translations
              // (tip move them in a JSON file and import them,
              // or even better, manage them via a UI: https://react.i18next.com/guides/multiple-translation-files#manage-your-translations-with-a-management-gui)
              resources: i18nextResources,
              lng: lng,
              fallbackLng: 'zh_CN',
              interpolation: {
                escapeValue: false,
                prefix: '{',
                suffix: '}'
              }
            });
          case 12:
            this._loadingData = 'End';
          case 13:
          case "end":
            return _context3.stop();
        }
      }, _callee3, this);
    }));
    function _handleData() {
      return _handleData2.apply(this, arguments);
    }
    return _handleData;
  }();
  _proto._fetchData = /*#__PURE__*/function () {
    var _fetchData2 = /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
      var url, res, en_US, zh_CN, _i, _Object$entries, _Object$entries$_i, key, value, result;
      return _regeneratorRuntime().wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            url = window.location.origin.includes('.freelog.com') ? ossJsonUrl : ossJsonUrl_Test;
            _context4.next = 3;
            return axios.get(url + '?timestamp=' + Date.now(), {
              withCredentials: false
            });
          case 3:
            res = _context4.sent;
            // console.log(res, 'data09oiw3qjelsfkdfjlsdkfjl');
            en_US = {};
            zh_CN = {};
            for (_i = 0, _Object$entries = Object.entries(res); _i < _Object$entries.length; _i++) {
              _Object$entries$_i = _Object$entries[_i], key = _Object$entries$_i[0], value = _Object$entries$_i[1];
              // console.log(key, value, 'key, value90iowsldfjlsdkj');
              en_US[key] = value['en_US'];
              zh_CN[key] = value['zh_CN'];
            }
            result = {
              en_US: {
                translation: en_US
              },
              zh_CN: {
                translation: zh_CN
              }
            };
            window.localStorage.setItem(localStorage_i18nextResources_key, JSON.stringify(result));
            return _context4.abrupt("return", result);
          case 10:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    }));
    function _fetchData() {
      return _fetchData2.apply(this, arguments);
    }
    return _fetchData;
  }();
  return I18nNext;
}();

var FI18n = {
  i18nNext: /*#__PURE__*/new I18nNext()
};

export { FI18n, FServiceAPI, FUtil };
//# sourceMappingURL=tools-lib.esm.js.map
